const config = require("../config.js");
const UTILS = require("./utils.js");
const COLORS = require("../data/colors.js");
module.exports = function (p17838, p17839, p17840, p17841, p17842, p17843, p17844, p17845, p17846, p17847, p17848) {
  var v13925;
  var vThis142 = this;
  this.tmp = {};
  this.bundleMedalFilters = function () {
    var vA784 = [];
    if (vThis142.tmp.medalSat != 1) {
      vA784.push("saturate(" + vThis142.tmp.medalSat * 100 + "%)");
    }
    if (vThis142.tmp.medalHue != 0) {
      vA784.push("hue-rotate(" + vThis142.tmp.medalHue * 3.6 + "deg)");
    }
    p17845.medalPrefab.filter = vA784.length ? vA784.join(" ") : null;
  };
  this.list = {
    defaultRegion: {
      name: "settings.local.region",
      info: "Connect to a specific region",
      cat: "local",
      noMod: true,
      mobileFriendly: true,
      get val() {
        return currentStorage[p17842.PING_REGION_CACHE_KEY];
      },
      set val(p17849) {},
      options: Object.fromEntries(Object.keys(config.availableRegions).map(p17850 => p17850 = [config.availableRegions[p17850], config.regionNames[config.availableRegions[p17850]]])),
      type: "select",
      set: function (p17851) {
        if (p17851 && config.isProd) {
          currentStorage.setItem(p17842.PING_REGION_CACHE_KEY, p17851);
        }
      }
    },
    lang: {
      name: "settings.local.lang",
      info: "Adjust localization",
      cat: "local",
      noMod: true,
      mobileFriendly: false,
      val: p17847.locale,
      options: Object.fromEntries(Object.keys(p17847.supported).map(p17852 => p17852 = [p17847.supported[p17852], config.langNames[p17847.supported[p17852]]])),
      type: "select",
      set: function (p17853) {
        if (p17853) {
          p17847.setLocale(p17853);
          if (windowHolder.style.display == "block") {
            p17844.toggleWindow(false, p17840.gamepad.active);
          }
        }
      }
    },
    netRate: {
      name: "settings.network.netRate",
      info: "Amount of data sent to server",
      cat: "network",
      val: p17840.isMobile ? 1 : 3,
      noMod: true,
      options: {
        0: 30,
        1: 60,
        2: 120,
        3: 144,
        4: 240,
        5: 360
      },
      type: "select",
      set: function (p17854) {
        vThis142.tmp[this.key] = this.options[p17854];
      }
    },
    lagComp: {
      name: "settings.network.lagComp",
      info: "Reduces the appearance of lag",
      cat: "network",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17855) {
        vThis142.tmp[this.key] = p17855;
      }
    },
    netRerouting: {
      name: "settings.network.netRerouting",
      info: "Use CloudFlare routing. May improve connection. Restart required",
      cat: "network",
      val: false,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function (p17856) {
        vThis142.tmp[this.key] = p17856;
      }
    },
    showNetStat: {
      name: "settings.network.net-stats",
      cat: "network",
      sType: "advanced",
      noMod: true,
      val: false,
      type: "switch",
      set: function (p17857) {
        p17846.trackPacketStats = p17857;
        p17846.resetPacketTally();
        window.updatePacketLoop(p17857);
        ingressDisplay.style.display = p17857 ? "block" : "none";
        egressDisplay.style.display = p17857 ? "block" : "none";
        tickDisplay.style.display = p17857 ? "block" : "none";
      }
    },
    oldBrowser: {
      name: "settings.serverb.oldBrowser",
      info: "Older server browser",
      cat: "serverb",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17858) {
        vThis142.tmp[this.key] = p17858;
      }
    },
    defaultRegionOnly: {
      name: "settings.serverb.defaultRegionOnly",
      info: "Display servers from your default region selection",
      cat: "serverb",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17859) {
        vThis142.tmp[this.key] = p17859;
      }
    },
    rawMouse: {
      name: "settings.experimental.rawMouse",
      info: "Use raw mouse input when available",
      cat: "experimental",
      val: false,
      type: "switch",
      set: function (p17860) {
        vThis142.tmp[this.key] = p17860;
        p17840.toggleMouseInputs(!!p17860);
      }
    },
    flickClamp: {
      name: "settings.experimental.mouseFlickFix",
      cat: "experimental",
      val: 200,
      min: 0,
      max: 500,
      step: 10,
      style: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.mouseFlick) + p17843._html.settings.input.slider(this);
      },
      set: function (p17861) {
        vThis142.tmp[this.key] = parseInt(p17861);
        p17840.flickClamp = parseInt(p17861);
      }
    },
    mouseFlick: {
      name: "settings.experimental.mouseFlickFix",
      info: "Prevents mouse from flicking too far",
      cat: "experimental",
      val: !!p17840.isMobile,
      hide: true,
      html: function () {},
      set: function (p17862) {
        vThis142.tmp[this.key] = !!p17862;
        p17840.mouseSkipFix = !!p17862;
      }
    },
    aimFreezeFix: {
      name: "settings.experimental.aimFreezeFix",
      info: "Possible fix for jittery/freezing aiming",
      cat: "experimental",
      val: false,
      type: "switch",
      set: function (p17863) {
        vThis142.tmp[this.key] = p17863;
      }
    },
    shaderRendering: {
      name: "settings.experimental.shaderRendering",
      cat: "experimental",
      val: false,
      needsRestart: true,
      info: "Requires Restart",
      type: "switch",
      set: function (p17864) {
        vThis142.tmp[this.key] = p17864;
      }
    },
    mouseAccel: {
      name: "settings.experimental.mouseAccel",
      cat: "experimental",
      val: true,
      hide: !!p17848,
      type: "switch",
      set: function (p17865) {
        vThis142.tmp[this.key] = p17865;
        p17840.mouseAccel = !!p17865;
      }
    },
    kpdVision: {
      name: "settings.kpd.vision",
      info: "KPD use only",
      cat: "kpd",
      kpd: true,
      val: true,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p17866) {
        vThis142.tmp[this.key] = p17866;
        p17845.kpdVision = !!p17866;
      }
    },
    kpdVisionCol: {
      name: "settings.kpd.visionCol",
      info: "KPD use only",
      cat: "kpd",
      kpd: true,
      val: "#00ffff",
      color: true,
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.kpdVision) + p17843._html.settings.input.color(this);
      },
      set: function (p17867) {
        vThis142.tmp[this.key] = p17867;
        p17845.kpdVisionCol = p17867;
      }
    },
    forceUpdate: {
      name: "settings.dev.forceUpdate",
      info: "Developer use only",
      cat: "dev",
      dev: true,
      val: true,
      type: "switch",
      set: function () {}
    },
    forceRegen: {
      name: "settings.dev.forceRegen",
      info: "Developer use only",
      cat: "dev",
      dev: true,
      val: false,
      type: "switch",
      set: function () {}
    },
    extraBan: {
      name: "settings.dev.extraBan",
      info: "Developer use only",
      cat: "dev",
      admin: true,
      val: false,
      type: "switch",
      set: function () {}
    },
    resolution: {
      name: "settings.quality.res",
      info: "Ratio of pixels displayed (lower to increase performance)",
      cat: "quality",
      mobileFriendly: true,
      pro: 1,
      perf: 0.4,
      val: p17840.isMobile ? 0.4 : 0.6,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p17868) {
        vThis142.tmp[this.key] = p17868;
        p17838.setResMlt(p17868);
        if ("updateClassRender" in window) {
          window.updateClassRender();
        }
      }
    },
    updateRate: {
      name: "settings.quality.updRate",
      info: "Frame per second cap (0 = unlimited)",
      cat: "quality",
      sType: "advanced",
      min: 0,
      max: 1200,
      val: 0,
      step: 10,
      type: "slider",
      set: function (p17869) {
        if (p17869 && p17869 < 10) {
          p17869 = 10;
        }
        vThis142.tmp[this.key] = p17869;
      }
    },
    aspectRatio: {
      name: "settings.quality.aspectRatio",
      info: "Force the page to fit monitor size (native = automatic)",
      cat: "quality",
      pro: "1280x1024",
      val: "",
      testfor: /^[-]?\d*x[-]?\d*$/g,
      placeholder: window.innerWidth + "x" + window.innerHeight,
      type: "input",
      html: function () {
        var vLSselectOnchangeaspect = "<select onchange='aspectSelect(\"aspectRatio\", this)' class='inputGrey2'>";
        vLSselectOnchangeaspect += "<option value='' disabled selected>Presets</option>";
        for (var vLN02544 = 0; vLN02544 < config.customRatios.length; vLN02544++) {
          vLSselectOnchangeaspect += "<option>" + config.customRatios[vLN02544] + "</option>";
        }
        vLSselectOnchangeaspect += "</select>";
        return vLSselectOnchangeaspect + p17843._html.settings.input.generic(this);
      },
      set: function (p17870) {
        vThis142.tmp[this.key] = p17870;
        p17838.aspectRatio = p17870;
        p17838.resize();
      }
    },
    antiAlias: {
      name: "settings.quality.antiAlias",
      info: "Smooth jagged lines. Restart required",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: false,
      toggle: true,
      needsRestart: true,
      type: "switch",
      set: function (p17871) {
        vThis142.tmp[this.key] = !!p17871;
        p17838.antiA = !!p17871;
      }
    },
    lowSpec: {
      name: "settings.quality.lowSpec",
      info: "Reduces quality to improve performance",
      cat: "quality",
      perf: true,
      val: false,
      toggle: true,
      mobileFriendly: true,
      type: "switch",
      set: function (p17872) {
        vThis142.tmp[this.key] = p17872;
        p17838.lowSpec = p17872;
      }
    },
    noTex: {
      name: "settings.quality.noTex",
      info: "Remove all textures. Restart required",
      cat: "quality",
      sType: "advanced",
      perf: true,
      val: false,
      toggle: true,
      mobileFriendly: true,
      needsRestart: true,
      type: "switch",
      set: function (p17873) {
        vThis142.tmp[this.key] = p17873;
        p17838.noTex = p17873;
      }
    },
    mapDet: {
      name: "settings.quality.mapDet",
      info: "Hide details such as grass. Restart required",
      cat: "quality",
      needsRestart: true,
      perf: false,
      val: !p17840.isMobile,
      mobileFriendly: true,
      toggle: true,
      type: "switch",
      set: function (p17874) {
        vThis142.tmp[this.key] = p17874;
        p17838.mapDet = p17874;
      }
    },
    particles: {
      name: "settings.quality.part",
      info: "Display particle effects",
      cat: "quality",
      pro: false,
      perf: false,
      mobileFriendly: true,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17875) {
        vThis142.tmp[this.key] = p17875;
        p17839.active = !!p17875;
      }
    },
    particlesDist: {
      name: "settings.quality.partdist",
      info: "Display particles within this distance",
      cat: "quality",
      val: 160,
      min: 10,
      max: 1000,
      mobileFriendly: true,
      step: 10,
      type: "slider",
      set: function (p17876) {
        vThis142.tmp[this.key] = p17876;
        p17839.partDst = p17876;
      }
    },
    renderDist: {
      name: "settings.quality.renderdist",
      info: "Render everything within this distance",
      cat: "quality",
      mobileFriendly: true,
      val: 100,
      min: 1,
      max: 100,
      step: 1,
      type: "slider",
      set: function (p17877) {
        vThis142.tmp[this.key] = p17877 * 60;
        p17838.camera.far = p17877 * 60;
      }
    },
    reflection: {
      name: "settings.quality.reflection",
      info: "Quality of reflected objects on water. Restart required",
      cat: "quality",
      sType: "advanced",
      val: p17840.isMobile ? 2 : 0,
      needsRestart: true,
      options: {
        0: "Map Dependent",
        1: 32,
        2: 64,
        3: 128,
        4: 256,
        5: 1024,
        6: 2048
      },
      type: "select",
      set: function (p17878) {
        vThis142.tmp[this.key] = parseInt(p17878);
        p17838.reflectionQuality = parseInt(p17878);
      }
    },
    shadows: {
      name: "settings.quality.shadows",
      info: "Render shadows from players and objects",
      cat: "quality",
      pro: false,
      perf: false,
      val: !p17840.isMobile,
      toggle: true,
      type: "switch",
      set: function (p17879) {
        vThis142.tmp[this.key] = p17879;
        p17838.toggleShadowMap(p17879);
      }
    },
    softShad: {
      name: "settings.quality.softShad",
      info: "Give shadows a softer appearance",
      cat: "quality",
      sType: "advanced",
      needsRestart: true,
      pro: false,
      perf: false,
      val: false,
      type: "switch",
      set: function (p17880) {
        vThis142.tmp[this.key] = !!p17880;
        p17838.toggleShadQual(!!p17880);
      }
    },
    highResShad: {
      name: "settings.quality.highResShad",
      info: "Improve shadow quality. Restart required",
      cat: "quality",
      sType: "advanced",
      needsRestart: true,
      pro: false,
      perf: false,
      val: false,
      type: "switch",
      set: function (p17881) {
        p17838.highResShad = !!p17881;
      }
    },
    shadowsDynamic: {
      name: "settings.quality.shadowsDynamic",
      info: "Shadows update real-time",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17882) {
        vThis142.tmp[this.key] = p17882;
        p17838.toggleShadowAuto(p17882);
      }
    },
    ambientShading: {
      name: "settings.quality.ambientOld",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17883) {
        vThis142.tmp[this.key] = p17883;
        p17838.toggleMeshGroup("ambient_1", p17883);
        p17838.toggleMeshGroup("ambient_0", p17883);
      }
    },
    showTrails: {
      name: "settings.quality.trails",
      info: "Displays a trail following bullets",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17884) {
        vThis142.tmp[this.key] = p17884;
        p17839.showTrails = p17884;
      }
    },
    yourTrails: {
      name: "settings.quality.yourTrails",
      info: "Displays your own bullet trail",
      cat: "quality",
      sType: "advanced",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17885) {
        vThis142.tmp[this.key] = p17885;
        p17839.yourTrails = p17885;
      }
    },
    muzzleFlash: {
      name: "settings.quality.mflash",
      info: "Flash of light when weapon is fired",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: !p17840.isMobile,
      toggle: true,
      type: "switch",
      set: function (p17886) {
        vThis142.tmp[this.key] = p17886;
        p17839.showMuzzle = p17886;
      }
    },
    bulletCasings: {
      name: "settings.quality.bulletC",
      info: "Bullet casings when weapon is fired",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17887) {
        vThis142.tmp[this.key] = p17887;
        p17839.showCasings = p17887;
      }
    },
    impactHoles: {
      name: "settings.quality.impacts",
      info: "Bullet hole when weapon impacts objects",
      cat: "quality",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17888) {
        vThis142.tmp[this.key] = p17888;
        p17839.showImpactHoles = p17888;
      }
    },
    sniperFlap: {
      name: "settings.quality.flap",
      info: "Animated flap to protect scope",
      cat: "quality",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17889) {
        vThis142.tmp[this.key] = p17889;
        p17838.sniperFlap = p17889;
      }
    },
    sniperFlapAnim: {
      name: "settings.quality.flapAnim",
      info: "Prevents sniper flap from moving",
      cat: "quality",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17890) {
        vThis142.tmp[this.key] = p17890;
        p17838.sniperFlapAnim = p17890;
      }
    },
    textureAnim: {
      name: "settings.quality.textureAnim",
      info: "Force textures to remain unanimated",
      cat: "quality",
      mobileFriendly: true,
      sType: "advanced",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17891) {
        vThis142.tmp[this.key] = p17891;
        p17838.textureAnim = p17891;
        if (!p17891) {
          for (var vLN02547 = 0; vLN02547 < p17838.movTextures.length; ++vLN02547) {
            v13925 = p17838.movTextures[vLN02547];
            if (v13925.tex.offset) {
              v13925.tex.offset[v13925.movD == 0 ? "x" : "y"] = 0;
            }
          }
          for (var vLN02547 = 0; vLN02547 < p17838.pulsMats.length; ++vLN02547) {
            p17838.pulsMats[vLN02547].mat.emissiveIntensity = 0;
          }
          for (var vLN02547 = 0; vLN02547 < p17838.frameMats.length; ++vLN02547) {
            v13925 = p17838.frameMats[vLN02547];
            v13925.dur = v13925.orgDur;
            v13925.cur = 0;
            if (v13925.mat.map) {
              v13925.mat.map.offset.x = v13925.cur % v13925.num / v13925.num;
            }
          }
        }
      }
    },
    objectAnim: {
      name: "settings.quality.objectAnim",
      cat: "quality",
      sType: "advanced",
      mobileFriendly: true,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17892) {
        vThis142.tmp[this.key] = p17892;
        p17838.objectAnim = p17892;
      }
    },
    screenShake: {
      name: "settings.quality.screenShake",
      info: "Move screen during explosion",
      cat: "quality",
      sType: "advanced",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17893) {
        vThis142.tmp[this.key] = p17893;
        p17838.screenShake = p17893;
        p17838.shakeX = 0;
        p17838.shakeY = 0;
      }
    },
    weaponShine: {
      name: "settings.quality.weaponShine",
      info: "Give shine to weapon skin",
      cat: "quality",
      sType: "advanced",
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17894) {
        vThis142.tmp[this.key] = p17894;
        p17838.weaponShine = p17894;
      }
    },
    lighting: {
      name: "settings.quality.lighting",
      info: "Render quality of game lighting. Restart required",
      cat: "quality",
      sType: "advanced",
      perf: 0,
      val: p17840.isMobile ? 0 : 1,
      needsRestart: true,
      options: {
        0: "Low",
        1: "Normal",
        2: "High",
        3: "Physical"
      },
      type: "select",
      set: function (p17895) {
        vThis142.tmp[this.key] = p17895;
        p17838.lighting = p17895;
      }
    },
    showExplo: {
      name: "settings.quality.showExplo",
      info: "Display explosion animation and particles",
      cat: "quality",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17896) {
        vThis142.tmp[this.key] = p17896;
      }
    },
    postProcessing: {
      name: "settings.post.post",
      info: "Toggles visual post effects",
      cat: "post",
      val: !p17840.isMobile,
      type: "switch",
      set: function (p17897) {
        vThis142.tmp[this.key] = p17897;
        p17838.postprocessing.enabled = p17897;
      }
    },
    scaleUI: {
      name: "settings.interface.scale",
      info: "Scales the menu UI",
      cat: "interface",
      perf: 1,
      val: p17840.isMobile ? 0.9 : 0.7,
      min: 0.1,
      max: 1,
      step: 0.1,
      style: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.uiScaling) + p17843._html.settings.input.slider(this);
      },
      set: function (p17898) {
        vThis142.tmp[this.key] = 1 + (1 - p17898);
        window.scaleBase(null, true);
      }
    },
    uiScaling: {
      name: "settings.interface.scale",
      info: "Scales HUD size",
      cat: "interface",
      val: true,
      hide: true,
      html: function () {},
      set: function (p17899) {
        vThis142.tmp[this.key] = p17899;
        window.scaleBase(null, true);
      }
    },
    showUI: {
      name: "settings.interface.ui",
      info: "Hide HUD in-game",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17900) {
        vThis142.tmp[this.key] = !!p17900;
        p17844.hideGameUI = !p17900;
        chatUI.style.display = p17900 ? "block" : "none";
        window.refreshChat();
      }
    },
    oldScoreboard: {
      name: "settings.interface.scoreboard",
      info: "Use Classic io Scoreboard",
      cat: "interface",
      sType: "advanced",
      val: !!p17840.isMobile,
      toggle: true,
      type: "switch",
      set: function (p17901) {
        vThis142.tmp[this.key] = p17901;
        window.switchLeaderboard(p17901);
      }
    },
    disableRarityAnim: {
      name: "settings.interface.rarityanim",
      info: "Use unanimated color for rarity",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17902) {
        vThis142.tmp[this.key] = !p17902;
        p17838.rarityAnim = !p17902;
        refreshClassDisplay();
      }
    },
    showPfp: {
      name: "settings.interface.showPfp",
      info: "Hide custom profile pictures",
      cat: "interface",
      sType: "advanced",
      val: !p17840.isMobile,
      toggle: true,
      type: "switch",
      set: function (p17903) {
        vThis142.tmp[this.key] = p17903;
      }
    },
    dynamicHP: {
      name: "settings.interface.hp",
      cat: "interface",
      sType: "advanced",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17904) {
        vThis142.tmp[this.key] = p17904;
        p17845.dynamicHP = p17904;
      }
    },
    showHitInd: {
      name: "settings.interface.hitInd",
      info: "Indicator appears when a bullet hits a player",
      cat: "interface",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17905) {
        vThis142.tmp[this.key] = p17905;
        p17845.showHits = p17905;
        if (!p17905 && p17845.hits) {
          p17845.hits.length = 0;
        }
      }
    },
    hitColor: {
      name: "settings.interface.hitColor",
      info: "Color for hit indicator",
      cat: "interface",
      sType: "advanced",
      val: "#FF3F3F",
      color: true,
      type: "color",
      set: function (p17906) {
        vThis142.tmp[this.key] = UTILS.hexToRGB(p17906).join(",");
        p17845.hitColor = UTILS.hexToRGB(p17906).join(",");
      }
    },
    deathMarkerOpac: {
      name: "settings.interface.deathMarkers",
      info: "Indicator appears when you or a teammate dies",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      style: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.select(vThis142.list.deathMarkers) + p17843._html.settings.input.slider(this);
      },
      set: function (p17907) {
        vThis142.tmp[this.key] = p17907;
        p17845.deathMarkerOpacity = parseFloat(p17907) || 0;
      }
    },
    deathMarkers: {
      name: "settings.interface.deathMarkers",
      info: "Indicator appears when you or a teammate dies",
      cat: "interface",
      sType: "advanced",
      perf: false,
      hide: true,
      val: 0,
      options: {
        0: "All",
        1: "Self Only",
        2: "Team Only",
        3: "None"
      },
      type: "select",
      html: function () {},
      set: function (p17908) {
        vThis142.tmp[this.key] = p17908;
        p17845.deathMarkerDisplay = parseInt(p17908) || 0;
        if (p17908 == 3 && p17845.deathMarkers) {
          p17845.deathMarkers.length = 0;
        }
      }
    },
    deathMarkerAdsOpac: {
      name: "settings.interface.deathMarkersAds",
      info: "Deathmarker opacity while aiming",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17909) {
        vThis142.tmp[this.key] = p17909;
        p17845.deathMarkerAdsOpacity = parseFloat(p17909) || 0;
      }
    },
    deathMarkerDur: {
      name: "settings.interface.deathMarkersDur",
      info: "How long a death marker displays",
      cat: "interface",
      sType: "advanced",
      val: 7,
      min: 0,
      max: 10,
      step: 1,
      type: "slider",
      set: function (p17910) {
        vThis142.tmp[this.key] = p17910;
        p17845.deathMarkerDuration = parseInt(p17910) || 0;
      }
    },
    dmgType: {
      name: "settings.interface.dmgType",
      info: "Display damage amount on hit",
      cat: "interface",
      sType: "advanced",
      val: 1,
      options: {
        0: p17847.t("settings.interface.dmgType.default"),
        1: p17847.t("settings.interface.dmgType.float")
      },
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.showDMG) + p17843._html.settings.input.select(this);
      },
      set: function (p17911) {
        vThis142.tmp[this.key] = p17911;
        p17845.dmgType = p17911;
      }
    },
    showDMG: {
      name: "settings.interface.dmg",
      info: "Display damage amount on hit",
      cat: "interface",
      sType: "advanced",
      pro: false,
      perf: false,
      val: true,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p17912) {
        vThis142.tmp[this.key] = p17912;
        p17845.showDMG = p17912;
      }
    },
    dmgColor: {
      name: "settings.interface.dmgCol",
      info: "Color for damage indicator",
      cat: "interface",
      sType: "advanced",
      val: COLORS.damage,
      color: true,
      type: "color",
      set: function (p17913) {
        vThis142.tmp[this.key] = p17913;
        p17845.dmgColor = p17913;
      }
    },
    critColor: {
      name: "settings.interface.critCol",
      info: "Color used when dealing critical damage",
      cat: "interface",
      sType: "advanced",
      val: COLORS.critical,
      color: true,
      type: "color",
      set: function (p17914) {
        vThis142.tmp[this.key] = p17914;
        p17845.critColor = p17914;
      }
    },
    dmgScale: {
      name: "settings.interface.dmgScale",
      info: "Size of Damage indicator",
      cat: "interface",
      sType: "advanced",
      pro: 0.5,
      val: 1,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p17915) {
        vThis142.tmp[this.key] = p17915 * 30;
        p17845.dmgScale = p17915 * 30;
      }
    },
    showKills: {
      name: "settings.interface.killf",
      info: "Display Kill feed",
      cat: "interface",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17916) {
        killFeed.style.display = p17916 ? "inline-grid" : "none";
        vThis142.tmp[this.key] = p17916;
      }
    },
    showKillC: {
      name: "settings.interface.kills",
      info: "Display your kills",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17917) {
        vThis142.tmp[this.key] = p17917;
        killCount.style.display = p17917 ? "inline-block" : "none";
      }
    },
    showDeaths: {
      name: "settings.interface.deaths",
      info: "Display your deaths",
      cat: "interface",
      sType: "advanced",
      pro: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17918) {
        vThis142.tmp[this.key] = p17918;
        deathCount.style.display = p17918 ? "inline-block" : "none";
      }
    },
    showKD: {
      name: "settings.interface.kd",
      info: "Display your K/D Ratio",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17919) {
        vThis142.tmp[this.key] = p17919;
        kdCount.style.display = p17919 ? "inline-block" : "none";
      }
    },
    showScore: {
      name: "settings.interface.score",
      info: "Display your score",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17920) {
        vThis142.tmp[this.key] = p17920;
        scoreCount.style.display = p17920 ? "inline-block" : "none";
      }
    },
    showStreak: {
      name: "settings.interface.streak",
      info: "Display your current killstreak",
      cat: "interface",
      sType: "advanced",
      pro: true,
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17921) {
        vThis142.tmp[this.key] = p17921;
        streakCount.style.display = p17921 ? "inline-block" : "none";
      }
    },
    showPing: {
      name: "settings.interface.ping",
      info: "Display most recent ping",
      cat: "interface",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17922) {
        vThis142.tmp[this.key] = p17922;
        pingDisplay.style.display = p17922 ? "block" : "none";
      }
    },
    showFPS: {
      name: "settings.interface.fps",
      info: "Display Frames per Second",
      cat: "interface",
      pro: true,
      perf: false,
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17923) {
        vThis142.tmp[this.key] = p17923;
        fpsDisplay.style.display = menuFPSDisplay.style.display = p17923 ? "block" : "none";
      }
    },
    fpsRate: {
      name: "settings.interface.fps.rate",
      info: "FPS display update rate",
      cat: "interface",
      val: 100,
      min: 0,
      max: 1000,
      step: 10,
      type: "slider",
      set: function (p17924) {
        vThis142.tmp[this.key] = p17924;
      }
    },
    showSpeed: {
      name: "settings.interface.speed",
      info: "Display movement speed",
      cat: "interface",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17925) {
        vThis142.tmp[this.key] = p17925;
        p17845.speedDisplay.display = p17925;
      }
    },
    speedOffX: {
      name: "settings.interface.speedOffX",
      info: "Move Speed indicator left or right",
      cat: "interface",
      sType: "advanced",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p17926) {
        vThis142.tmp[this.key] = p17926 * 10;
        p17845.speedDisplay.left = p17926 * 10;
      }
    },
    speedOffY: {
      name: "settings.interface.speedOffY",
      info: "Move Speed indicator up or down",
      cat: "interface",
      sType: "advanced",
      val: 5.4,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p17927) {
        vThis142.tmp[this.key] = p17927 * 10;
        p17845.speedDisplay.top = p17927 * 10;
      }
    },
    speedScale: {
      name: "settings.interface.speedScale",
      info: "Size of speed indicator",
      cat: "interface",
      sType: "advanced",
      val: 2.4,
      min: 0.5,
      max: 5,
      step: 0.1,
      type: "slider",
      set: function (p17928) {
        vThis142.tmp[this.key] = p17928 * 10;
        p17845.speedDisplay.fontSize = p17928 * 10;
      }
    },
    speedOpacity: {
      name: "settings.interface.speedOpacity",
      info: "Opacity of speed indicator",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17929) {
        vThis142.tmp[this.key] = p17929;
        p17845.speedDisplay.opacity = p17929;
      }
    },
    speedColor: {
      name: "settings.interface.speedColor",
      info: "Color for your current speed",
      cat: "interface",
      sType: "advanced",
      val: "#ffea78",
      color: true,
      type: "color",
      set: function (p17930) {
        vThis142.tmp[this.key] = p17930;
        p17845.speedDisplay.color = p17930;
      }
    },
    speedColorMax: {
      name: "settings.interface.speedColorMax",
      info: "Color for your max-recorded speed",
      cat: "interface",
      sType: "advanced",
      val: "#ff0000",
      color: true,
      type: "color",
      set: function (p17931) {
        vThis142.tmp[this.key] = p17931;
        p17845.speedDisplay.colorMax = p17931;
      }
    },
    hideNames: {
      name: "settings.interface.hideNames",
      info: "Display nametags for everyone, no one, team, or enemies",
      cat: "interface",
      mobileFriendly: true,
      val: 0,
      options: {
        0: p17847.t("settings.interface.hideNames.all"),
        1: p17847.t("settings.interface.hideNames.team"),
        2: p17847.t("settings.interface.hideNames.enemy"),
        3: p17847.t("generic.off")
      },
      type: "select",
      set: function (p17932) {
        vThis142.tmp[this.key] = p17932;
      }
    },
    nametagOpac: {
      name: "settings.interface.nametagOpac",
      info: "Opacity for nametags",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17933) {
        vThis142.tmp[this.key] = p17933;
        p17845.nametagOpacity = p17933;
      }
    },
    nametagScale: {
      name: "settings.interface.nametagScale",
      info: "Size of nametags",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17934) {
        vThis142.tmp[this.key] = p17934;
        p17845.nametagScale = p17934;
      }
    },
    nametagStyle: {
      name: "settings.interface.nametagStyle",
      info: "Display level, name, and health with nametags",
      cat: "interface",
      sType: "advanced",
      val: 0,
      options: {
        0: p17847.t("settings.interface.nametagStyle.all"),
        1: p17847.t("settings.interface.nametagStyle.name"),
        2: p17847.t("settings.interface.nametagStyle.nameLvl"),
        3: p17847.t("settings.interface.nametagStyle.health")
      },
      type: "select",
      set: function (p17935) {
        vThis142.tmp[this.key] = p17935;
        p17845.nametagStyle = p17935;
      }
    },
    healthNum: {
      name: "settings.interface.healthNum",
      info: "Include number to indicate current health",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17936) {
        vThis142.tmp[this.key] = p17936;
        p17845.healthNum = p17936;
      }
    },
    healthColT: {
      name: "settings.interface.healthColT",
      info: "Color for team health bar",
      cat: "interface",
      sType: "advanced",
      val: COLORS.teams[0],
      color: true,
      type: "color",
      set: function (p17937) {
        vThis142.tmp[this.key] = p17937;
        p17845.healthColT = p17937;
      }
    },
    healthColE: {
      name: "settings.interface.healthColE",
      info: "Color for enemy health bar",
      cat: "interface",
      sType: "advanced",
      val: COLORS.teams[1],
      color: true,
      type: "color",
      set: function (p17938) {
        vThis142.tmp[this.key] = p17938;
        p17845.healthColE = p17938;
      }
    },
    objOpac: {
      name: "settings.interface.objOpac",
      info: "Opacity for Objective Info",
      cat: "interface",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17939) {
        vThis142.tmp[this.key] = p17939;
        p17845.objectiveOpacity = p17939;
      }
    },
    adsObjOpac: {
      name: "settings.interface.adsObjOpac",
      info: "Opacity for Objective Info while adsing",
      cat: "interface",
      sType: "advanced",
      val: 0.5,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17940) {
        vThis142.tmp[this.key] = p17940;
        p17845.adsObjectiveOpacity = p17940;
      }
    },
    hideNonTrade: {
      name: "settings.interface.hideNonTrade",
      cat: "interface",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17941) {
        vThis142.tmp[this.key] = p17941;
      }
    },
    showMinimap: {
      name: "settings.minimap.show",
      cat: "minimap",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17942) {
        vThis142.tmp[this.key] = p17942;
        if (window && window.toggleMinimap) {
          window.toggleMinimap(!!p17942);
        }
      }
    },
    minimapScale: {
      name: "settings.minimap.scale",
      cat: "minimap",
      sType: "advanced",
      val: 1,
      min: 0.5,
      max: 1.5,
      step: 0.1,
      type: "slider",
      set: function (p17943) {
        vThis142.tmp[this.key] = p17943;
        p17845.miniMap.setScale(parseFloat(p17943));
      }
    },
    minimapZoom: {
      name: "settings.minimap.zoom",
      cat: "minimap",
      sType: "advanced",
      val: 1,
      min: 0.5,
      max: 1.5,
      step: 0.1,
      type: "slider",
      set: function (p17944) {
        vThis142.tmp[this.key] = p17944;
        p17845.miniMap.setZoom(parseFloat(p17944));
      }
    },
    miniMapHudScale: {
      name: "settings.minimap.scale.hud",
      cat: "minimap",
      sType: "advanced",
      val: 1,
      min: 0.5,
      max: 1.5,
      step: 0.1,
      type: "slider",
      set: function (p17945) {
        vThis142.tmp[this.key] = p17945;
        p17845.miniMap.setHudScale(parseFloat(p17945));
      }
    },
    showMedals: {
      name: "settings.medals.show",
      cat: "medals",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17946) {
        vThis142.tmp[this.key] = p17946;
      }
    },
    classicMedals: {
      name: "settings.medals.classic",
      cat: "medals",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17947) {
        vThis142.tmp[this.key] = p17947;
      }
    },
    playMedals: {
      name: "settings.medals.sound",
      info: "Toggle sounds emmited from medals",
      cat: "medals",
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17948) {
        vThis142.tmp[this.key] = p17948;
        p17845.medalPrefab.sound = !!p17948;
      }
    },
    medalScale: {
      name: "settings.medals.scale",
      info: "Size of medals",
      cat: "medals",
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p17949) {
        vThis142.tmp[this.key] = p17949;
        p17845.medalPrefab.scale = p17949;
      }
    },
    medalOffX: {
      name: "settings.medals.xOff",
      info: "Move medals left or right",
      cat: "medals",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p17950) {
        vThis142.tmp[this.key] = p17950 * 10;
        p17845.medalPrefab.left = p17950 * 10;
      }
    },
    medalOffY: {
      name: "settings.medals.yOff",
      info: "Move medals up or down",
      cat: "medals",
      val: 1,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p17951) {
        vThis142.tmp[this.key] = p17951 * 10;
        p17845.medalPrefab.top = p17951 * 10;
      }
    },
    medalSat: {
      name: "settings.medals.saturation",
      info: "Increase color saturation of medals",
      cat: "medals",
      mobileFriendly: true,
      val: 1,
      perf: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function (p17952) {
        vThis142.tmp[this.key] = p17952;
        vThis142.bundleMedalFilters();
      }
    },
    medalHue: {
      name: "settings.medals.hue",
      info: "Shift colors of medals",
      cat: "medals",
      val: 0,
      min: 0,
      max: 100,
      step: 5,
      type: "slider",
      set: function (p17953) {
        vThis142.tmp[this.key] = p17953;
        vThis142.bundleMedalFilters();
      }
    },
    shwChat: {
      name: "settings.chat.chat",
      info: "Show chat box all the time, only when typing, and never",
      cat: "chat",
      val: 0,
      options: {
        0: p17847.t("settings.chat.chat.all"),
        1: p17847.t("settings.chat.chat.focus"),
        2: p17847.t("generic.off")
      },
      type: "select",
      set: function (p17954) {
        vThis142.tmp[this.key] = p17954;
        chatList.style.display = p17954 == 0 ? "block" : "none";
      }
    },
    chatFilter: {
      name: "settings.chat.chatFilter",
      info: "Hide profanity in chat",
      cat: "chat",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17955) {
        vThis142.tmp[this.key] = p17955;
      }
    },
    showMessages: {
      name: "settings.chat.messages",
      info: "Display player chat messages",
      cat: "chat",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17956) {
        vThis142.tmp[this.key] = p17956;
      }
    },
    showUnboxings: {
      name: "settings.chat.unboxings",
      info: "Display player unboxings",
      cat: "chat",
      pro: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17957) {
        vThis142.tmp[this.key] = p17957;
      }
    },
    chatOp: {
      name: "settings.chat.chatOp",
      info: "Opacity for Chat box",
      cat: "chat",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17958) {
        vThis142.tmp[this.key] = p17958;
        chatList.style.opacity = p17958;
      }
    },
    chatBGOp: {
      name: "settings.chat.chatBGOp",
      info: "Opacity for chat background",
      cat: "chat",
      val: 0.2,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17959) {
        vThis142.tmp[this.key] = p17959;
        Array.from(document.getElementsByClassName("chatItem")).forEach(function (p17960) {
          p17960.style.backgroundColor = "rgba(0, 0, 0, " + p17959 + ")";
        });
      }
    },
    chatTextOutline: {
      name: "settings.chat.chatTextOutline",
      info: "Give chat messages a black outline",
      cat: "chat",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p17961) {
        vThis142.tmp[this.key] = p17961;
        Array.from(document.getElementsByClassName("chatItem")).forEach(function (p17962) {
          p17962.classList.toggle("chatTextOutline", p17961);
        });
      }
    },
    chatHeight: {
      name: "settings.chat.chatHeight",
      info: "Size of chatbox height",
      cat: "chat",
      val: 2.5,
      min: 0,
      max: 5,
      step: 0.1,
      type: "slider",
      set: function (p17963) {
        vThis142.tmp[this.key] = p17963 * 100 + "px";
        chatList.style.maxHeight = p17963 * 100 + "px";
        window.refreshChat();
      }
    },
    chatTimer: {
      name: "settings.chat.chatTimer",
      info: "Chat messages will only appear for this many seconds (0 = no timer)",
      cat: "chat",
      val: 0,
      min: 0,
      max: 10,
      step: 0.5,
      type: "slider",
      set: function (p17964) {
        vThis142.tmp[this.key] = p17964;
        window.updateChatTimer(p17964);
      }
    },
    crosshairSho: {
      name: "settings.crosshair.type",
      info: "Type of crosshair displayed",
      cat: "crosshair",
      pro: 4,
      val: 1,
      options: {
        0: p17847.t("generic.off"),
        1: p17847.t("settings.crosshair.type.1"),
        2: p17847.t("settings.crosshair.type.2"),
        3: p17847.t("settings.crosshair.type.3"),
        4: p17847.t("settings.crosshair.type.4"),
        5: p17847.t("settings.crosshair.type.5")
      },
      type: "select",
      set: function (p17965) {
        vThis142.tmp[this.key] = p17965;
        p17845.crosshairType = p17965;
        let v13926;
        let vA785 = ["crosshairAlways", "crosshairOpacity", "crosshairLen", "crosshairThick"];
        for (let v13927 of vA785) {
          vThis142.list[v13927].hide = v13927 == "crosshairAlways" || v13927 == "crosshairOpacity" ? p17965 < 2 : p17965 == 4 || p17965 < 2;
          v13926 = document.getElementById(v13927 + "_div");
          if (v13926) {
            v13926.style.display = vThis142.list[v13927].hide ? "none" : "block";
          }
        }
        for (let v13928 of ["crosshairColor", "crosshairShadow", "crosshairShadowThickess"]) {
          vThis142.list[v13928].hide = p17965 < 1 || p17965 == 4;
          v13926 = document.getElementById(v13928 + "_div");
          if (v13926) {
            v13926.style.display = vThis142.list[v13928].hide ? "none" : "block";
          }
        }
        for (let v13929 of ["crosshairImage", "crosshairImageW", "crosshairImageH"]) {
          vThis142.list[v13929].hide = p17965 != 4;
          v13926 = document.getElementById(v13929 + "_div");
          if (v13926) {
            v13926.style.display = vThis142.list[v13929].hide ? "none" : "block";
          }
        }
        vThis142.list.crosshairGap.hide = p17965 != 5;
        v13926 = document.getElementById("crosshairGap_div");
        if (v13926) {
          v13926.style.display = vThis142.list.crosshairGap.hide ? "none" : "block";
        }
        vThis142.list.crosshairDot.hide = p17965 != 5 && p17965 != 1;
        v13926 = document.getElementById("crosshairDot_div");
        if (v13926) {
          v13926.style.display = vThis142.list.crosshairDot.hide ? "none" : "block";
        }
        vThis142.list.crosshairStyle.hide = p17965 > 3 || p17965 < 2;
        v13926 = document.getElementById("crosshairStyle_div");
        if (v13926) {
          v13926.style.display = vThis142.list.crosshairStyle.hide ? "none" : "block";
        }
      }
    },
    crosshairStyle: {
      name: "settings.crosshair.style",
      info: "Crosshair preset",
      cat: "crosshair",
      val: 0,
      hide: true,
      options: {
        0: p17847.t("settings.crosshair.style.0"),
        1: p17847.t("settings.crosshair.style.1"),
        2: p17847.t("settings.crosshair.style.2"),
        3: p17847.t("settings.crosshair.style.3"),
        4: p17847.t("settings.crosshair.style.4")
      },
      type: "select",
      set: function (p17966) {
        vThis142.tmp[this.key] = p17966;
        p17845.crosshairStyle = p17966;
      }
    },
    crosshairImage: {
      name: "settings.crosshair.image",
      info: "Custom crosshair image",
      cat: "crosshair",
      pro: UTILS.assetsUrl("pro_crosshair.png"),
      val: "",
      hide: true,
      img: true,
      placeholder: p17847.t("settings.crosshair.image.paste"),
      type: "url",
      collection: true,
      set: function (p17967) {
        p17967 = UTILS.isURL(p17967) && !/\.svg/.test(p17967) ? p17967 : "";
        if (p17967.length) {
          if (p17967.includes(".gif")) {
            var v13930 = p17845.HELPER.GIF();
            p17845.crosshairImage.isReady = false;
            v13930.onload = () => {
              p17845.crosshairImage = v13930;
              p17845.crosshairImage.isReady = true;
            };
            v13930.load(p17967);
          } else {
            var v13931 = !!p17845.crosshairImage.frames;
            if (v13931) {
              p17845.crosshairImage = new Image();
              p17845.crosshairImage.onload = () => p17845.crosshairImage.isReady = true;
              p17845.crosshairImage.src = p17967;
            } else if (p17845.crosshairImage.src != p17967) {
              p17845.crosshairImage.isReady = false;
              p17845.crosshairImage.onload = () => p17845.crosshairImage.isReady = true;
              p17845.crosshairImage.src = p17967;
            }
          }
        }
      }
    },
    crosshairImageW: {
      name: "settings.crosshair.image.width",
      info: "Width of crosshair image",
      cat: "crosshair",
      val: 0,
      min: 0,
      max: 1000,
      step: 1,
      hide: true,
      type: "slider",
      set: function (p17968) {
        vThis142.tmp[this.key] = p17968;
        p17845.crosshairImageW = p17968;
      }
    },
    crosshairImageH: {
      name: "settings.crosshair.image.height",
      info: "Height of crosshair image",
      cat: "crosshair",
      val: 0,
      min: 0,
      max: 1000,
      step: 1,
      hide: true,
      type: "slider",
      set: function (p17969) {
        vThis142.tmp[this.key] = p17969;
        p17845.crosshairImageH = p17969;
      }
    },
    crosshairOpacity: {
      name: "settings.crosshair.opacity.custom",
      info: "Opacity for crosshair",
      cat: "crosshair",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      hide: true,
      type: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.crosshairUseOpacity) + p17843._html.settings.input.slider(this);
      },
      set: function (p17970) {
        vThis142.tmp[this.key] = p17970;
        p17845.crosshairOpacityCustom = p17970;
      }
    },
    crosshairUseOpacity: {
      name: "settings.crosshair.opacity.use",
      cat: "crosshair",
      val: false,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p17971) {
        vThis142.tmp[this.key] = p17971;
        p17845.crosshairUseOpacityCustom = p17971;
      }
    },
    crosshairAlways: {
      name: "settings.crosshair.always",
      info: "Display crosshair while aiming down sight",
      cat: "crosshair",
      pro: true,
      val: false,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (p17972) {
        vThis142.tmp[this.key] = p17972;
        p17845.crosshairAlways = p17972;
      }
    },
    crosshairColor: {
      name: "settings.crosshair.color",
      info: "Color for crosshair",
      cat: "crosshair",
      val: COLORS.crosshair.background,
      color: true,
      type: "color",
      set: function (p17973) {
        vThis142.tmp[this.key] = p17973;
        p17845.crosshairColor = p17973;
      }
    },
    crosshairShadow: {
      name: "settings.crosshair.shadow.color",
      info: "Color of crosshair shadow",
      cat: "crosshair",
      val: COLORS.crosshair.shadow,
      color: true,
      type: "color",
      set: function (p17974) {
        vThis142.tmp[this.key] = p17974;
        p17845.crosshairShadow = p17974;
      }
    },
    crosshairShadowThickess: {
      name: "settings.crosshair.shadow.thickness",
      info: "Crosshair shadow thickness",
      cat: "crosshair",
      val: 1,
      min: 0,
      max: 3,
      step: 0.1,
      hide: true,
      type: "slider",
      set: function (p17975) {
        vThis142.tmp[this.key] = p17975;
        p17845.crosshairShadowThickness = p17975;
      }
    },
    crosshairThick: {
      name: "settings.crosshair.thickness",
      info: "Crosshair thickness",
      cat: "crosshair",
      val: 2,
      min: 0,
      max: 100,
      step: 0.5,
      hide: true,
      type: "slider",
      set: function (p17976) {
        vThis142.tmp[this.key] = p17976;
        p17845.crosshairThick = p17976;
      }
    },
    crosshairLen: {
      name: "settings.crosshair.size",
      cat: "crosshair",
      val: 16,
      min: 0,
      max: 100,
      step: 0.5,
      hide: true,
      type: "slider",
      set: function (p17977) {
        vThis142.tmp[this.key] = p17977;
        p17845.crosshairLen = p17977;
      }
    },
    crosshairGap: {
      name: "settings.crosshair.gap",
      info: "Gap between center dot and lines",
      cat: "crosshair",
      val: 0,
      min: -100,
      max: 100,
      step: 1,
      hide: true,
      type: "slider",
      set: function (p17978) {
        vThis142.tmp[this.key] = p17978;
        p17845.crosshairGap = p17978;
      }
    },
    crosshairDot: {
      name: "settings.crosshair.dot",
      info: "Display center dot in crosshair",
      cat: "crosshair",
      val: true,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (p17979) {
        vThis142.tmp[this.key] = p17979;
        p17845.crosshairDot = p17979;
      }
    },
    crosshairShoM: {
      name: "settings.crosshairm.type",
      info: "Crosshair used while throwing knife",
      cat: "crosshairm",
      pro: 4,
      val: 3,
      options: {
        0: p17847.t("generic.off"),
        1: p17847.t("settings.crosshairm.type.1"),
        2: p17847.t("settings.crosshairm.type.2"),
        3: p17847.t("settings.crosshairm.type.3")
      },
      type: "select",
      set: function (p17980) {
        vThis142.tmp[this.key] = p17980;
        p17845.crosshairTypeM = p17980;
        let v13932;
        let vA786 = ["crosshairAlwaysM", "crosshairOpacityM", "crosshairLenM", "crosshairThickM"];
        for (let v13933 of vA786) {
          vThis142.list[v13933].hide = v13933 == "crosshairAlwaysM" || v13933 == "crosshairOpacityM" ? p17980 < 1 : p17980 == 2 || p17980 < 1;
          v13932 = document.getElementById(v13933 + "_div");
          if (v13932) {
            v13932.style.display = vThis142.list[v13933].hide ? "none" : "block";
          }
        }
        for (let v13934 of ["crosshairColorM", "crosshairShadowM", "crosshairShadowThickessM"]) {
          vThis142.list[v13934].hide = p17980 < 1 || p17980 == 2;
          v13932 = document.getElementById(v13934 + "_div");
          if (v13932) {
            v13932.style.display = vThis142.list[v13934].hide ? "none" : "block";
          }
        }
        for (let v13935 of ["crosshairImageM", "crosshairImageWM", "crosshairImageHM"]) {
          vThis142.list[v13935].hide = p17980 != 2;
          v13932 = document.getElementById(v13935 + "_div");
          if (v13932) {
            v13932.style.display = vThis142.list[v13935].hide ? "none" : "block";
          }
        }
        vThis142.list.crosshairGapM.hide = p17980 != 3;
        v13932 = document.getElementById("crosshairGapM_div");
        if (v13932) {
          v13932.style.display = vThis142.list.crosshairGapM.hide ? "none" : "block";
        }
        vThis142.list.crosshairDotM.hide = p17980 != 3;
        v13932 = document.getElementById("crosshairDotM_div");
        if (v13932) {
          v13932.style.display = vThis142.list.crosshairDotM.hide ? "none" : "block";
        }
        vThis142.list.crosshairStyleM.hide = p17980 != 1;
        v13932 = document.getElementById("crosshairStyleM_div");
        if (v13932) {
          v13932.style.display = vThis142.list.crosshairStyleM.hide ? "none" : "block";
        }
      }
    },
    crosshairStyleM: {
      name: "settings.crosshairm.style",
      info: "Throwing crosshair preset",
      cat: "crosshairm",
      val: 0,
      hide: true,
      options: {
        0: p17847.t("settings.crosshairm.style.0"),
        1: p17847.t("settings.crosshairm.style.1"),
        2: p17847.t("settings.crosshairm.style.2"),
        3: p17847.t("settings.crosshairm.style.3"),
        4: p17847.t("settings.crosshairm.style.4")
      },
      type: "select",
      set: function (p17981) {
        vThis142.tmp[this.key] = p17981;
        p17845.crosshairStyleM = p17981;
      }
    },
    crosshairImageM: {
      name: "settings.crosshairm.image",
      info: "Custom throwing crosshair image",
      cat: "crosshairm",
      val: "",
      hide: true,
      img: true,
      placeholder: p17847.t("settings.crosshairm.image.paste"),
      type: "url",
      collection: true,
      set: function (p17982) {
        p17982 = UTILS.isURL(p17982) && !/\.svg/.test(p17982) ? p17982 : "";
        if (p17982.length) {
          if (p17982.includes(".gif")) {
            var v13936 = p17845.HELPER.GIF();
            p17845.crosshairImageM.isReady = false;
            v13936.onload = () => {
              p17845.crosshairImageM = v13936;
              p17845.crosshairImageM.isReady = true;
            };
            v13936.load(p17982);
          } else {
            var v13937 = !!p17845.crosshairImageM.frames;
            if (v13937) {
              p17845.crosshairImageM = new Image();
              p17845.crosshairImageM.onload = () => p17845.crosshairImageM.isReady = true;
              p17845.crosshairImageM.src = p17982;
            } else if (p17845.crosshairImage.src != p17982) {
              p17845.crosshairImageM.isReady = false;
              p17845.crosshairImageM.onload = () => p17845.crosshairImageM.isReady = true;
              p17845.crosshairImageM.src = p17982;
            }
          }
        }
      }
    },
    crosshairImageWM: {
      name: "settings.crosshairm.image.width",
      info: "Throwing crosshair image width",
      cat: "crosshairm",
      val: 0,
      min: 0,
      max: 1000,
      step: 1,
      hide: true,
      type: "slider",
      set: function (p17983) {
        vThis142.tmp[this.key] = p17983;
        p17845.crosshairImageWM = p17983;
      }
    },
    crosshairImageHM: {
      name: "settings.crosshairm.image.height",
      info: "Throwing crosshair image height",
      cat: "crosshairm",
      val: 0,
      min: 0,
      max: 1000,
      step: 1,
      hide: true,
      type: "slider",
      set: function (p17984) {
        vThis142.tmp[this.key] = p17984;
        p17845.crosshairImageHM = p17984;
      }
    },
    crosshairOpacityM: {
      name: "settings.crosshairm.opacity.custom",
      info: "Opacity for throwing crosshair",
      cat: "crosshairm",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      hide: true,
      type: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.crosshairUseOpacityM) + p17843._html.settings.input.slider(this);
      },
      set: function (p17985) {
        vThis142.tmp[this.key] = p17985;
        p17845.crosshairOpacityCustomM = p17985;
      }
    },
    crosshairUseOpacityM: {
      name: "settings.crosshairm.opacity.use",
      cat: "crosshairm",
      val: false,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p17986) {
        vThis142.tmp[this.key] = p17986;
        p17845.crosshairUseOpacityCustomM = p17986;
      }
    },
    crosshairAlwaysM: {
      name: "settings.crosshairm.always",
      info: "Always show throwing crosshair",
      cat: "crosshairm",
      pro: true,
      val: false,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (p17987) {
        vThis142.tmp[this.key] = p17987;
        p17845.crosshairAlwaysM = p17987;
      }
    },
    crosshairColorM: {
      name: "settings.crosshairm.color",
      info: "Color for throwing crosshair",
      cat: "crosshairm",
      val: COLORS.crosshair.background,
      color: true,
      type: "color",
      set: function (p17988) {
        vThis142.tmp[this.key] = p17988;
        p17845.crosshairColorM = p17988;
      }
    },
    crosshairShadowM: {
      name: "settings.crosshairm.shadow.color",
      type: "Color of throwing crosshair shadow",
      cat: "crosshairm",
      val: COLORS.crosshair.shadow,
      color: true,
      type: "color",
      set: function (p17989) {
        vThis142.tmp[this.key] = p17989;
        p17845.crosshairShadowM = p17989;
      }
    },
    crosshairShadowThickessM: {
      name: "settings.crosshairm.shadow.thickness",
      info: "Throwing crosshair shadow thickness",
      cat: "crosshairm",
      val: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function (p17990) {
        vThis142.tmp[this.key] = p17990;
        p17845.crosshairShadowThicknessM = p17990;
      }
    },
    crosshairThickM: {
      name: "settings.crosshairm.thickness",
      info: "Thickness of throwing crosshair",
      cat: "crosshairm",
      val: 3,
      min: 0,
      max: 100,
      step: 0.5,
      hide: true,
      type: "slider",
      set: function (p17991) {
        vThis142.tmp[this.key] = p17991;
        p17845.crosshairThickM = p17991;
      }
    },
    crosshairLenM: {
      name: "settings.crosshairm.size",
      cat: "crosshairm",
      val: 16,
      min: 0,
      max: 100,
      step: 0.5,
      type: "slider",
      set: function (p17992) {
        vThis142.tmp[this.key] = p17992;
        p17845.crosshairLenM = p17992;
      }
    },
    crosshairGapM: {
      name: "settings.crosshairm.gap",
      info: "Throwing crosshair gap from center dot",
      cat: "crosshairm",
      val: 14,
      min: 0,
      max: 100,
      step: 1,
      type: "slider",
      set: function (p17993) {
        vThis142.tmp[this.key] = p17993;
        p17845.crosshairGapM = p17993;
      }
    },
    crosshairDotM: {
      name: "settings.crosshairm.dot",
      info: "Display throwing crosshair dot",
      cat: "crosshairm",
      val: true,
      hide: true,
      toggle: true,
      type: "switch",
      set: function (p17994) {
        vThis142.tmp[this.key] = p17994;
        p17845.crosshairDotM = p17994;
      }
    },
    hitm: {
      name: "settings.hitmarker.hitm",
      info: "Display indicator when hit lands",
      cat: "hitmarker",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p17995) {
        vThis142.tmp[this.key] = p17995;
        p17845.hitSet.enabled = p17995;
      }
    },
    hitmCol: {
      name: "settings.hitmarker.color",
      info: "Color for hitmarker",
      cat: "hitmarker",
      val: "#FFFFFF",
      color: true,
      type: "color",
      set: function (p17996) {
        vThis142.tmp[this.key] = [[p17996, p17996], [p17996, p17996]];
        p17845.hitSet.colors = [[p17996, p17996], [p17996, p17996]];
      }
    },
    hitmKCol: {
      name: "settings.hitmarker.kcolor",
      info: "Color for hitmarker when hit kills player",
      cat: "hitmarker",
      val: "#FF0000",
      color: true,
      type: "color",
      set: function (p17997) {
        vThis142.tmp[this.key] = [[p17997, p17997], [p17997, p17997]];
        p17845.hitSet.kColors = [[p17997, p17997], [p17997, p17997]];
      }
    },
    hitOpac: {
      name: "settings.hitmarker.opacity",
      info: "Opacity for hitmarker",
      cat: "hitmarker",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p17998) {
        vThis142.tmp[this.key] = p17998;
        p17845.hitSet.opacity = p17998;
      }
    },
    hitmLen: {
      name: "settings.hitmarker.leng",
      info: "size of hitmarker",
      cat: "hitmarker",
      val: 25,
      min: 1,
      max: 50,
      step: 1,
      type: "slider",
      set: function (p17999) {
        vThis142.tmp[this.key] = p17999;
        p17845.hitSet.length = p17999;
      }
    },
    hitmThick: {
      name: "settings.hitmarker.thickness",
      info: "Hitmarker thickness",
      cat: "hitmarker",
      val: 7,
      min: 1,
      max: 20,
      step: 1,
      type: "slider",
      set: function (p18000) {
        vThis142.tmp[this.key] = p18000;
        p17845.hitSet.thickness = p18000;
      }
    },
    hitmSpac: {
      name: "settings.hitmarker.spacing",
      info: "Hitmarker indicator spread",
      cat: "hitmarker",
      val: 37,
      min: 5,
      max: 60,
      step: 1,
      type: "slider",
      set: function (p18001) {
        vThis142.tmp[this.key] = p18001;
        p17845.hitSet.spacing = p18001;
      }
    },
    hitmAnimD: {
      name: "settings.hitmarker.animD",
      info: "Hitmarker animation size",
      cat: "hitmarker",
      val: 0.14,
      min: 0.1,
      max: 0.5,
      step: 0.01,
      type: "slider",
      set: function (p18002) {
        vThis142.tmp[this.key] = p18002;
        p17845.hitSet.inc = p18002;
      }
    },
    hitmAnimS: {
      name: "settings.hitmarker.animS",
      info: "Hitmarker animation speed",
      cat: "hitmarker",
      val: 0.008,
      min: 0.001,
      max: 0.01,
      step: 0.001,
      type: "slider",
      set: function (p18003) {
        vThis142.tmp[this.key] = p18003;
        p17845.hitSet.speed = p18003;
      }
    },
    hitmFad: {
      name: "settings.hitmarker.hitmFad",
      info: "Hitmarker animation fade",
      cat: "hitmarker",
      val: 0.0062,
      min: 0.0001,
      max: 0.01,
      step: 0.0001,
      set: function (p18004) {
        vThis142.tmp[this.key] = p18004;
        p17845.hitSet.fadeOut = p18004;
      }
    },
    customHitmarker: {
      name: "settings.hitmarker.custom",
      info: "Custom hitmarker image",
      cat: "hitmarker",
      val: "",
      img: true,
      placeholder: p17847.t("settings.hitmarker.custom.paste"),
      type: "url",
      collection: true,
      set: function (p18005) {
        p18005 = UTILS.isURL(p18005) && !/\.svg/.test(p18005) ? p18005 : "";
        if (/\.(jpg|jpeg|png)/.test(p18005)) {
          if (p17845.hitmarker.image) {
            p17845.hitmarker.isReady = false;
            p17845.hitmarker.image.onload = () => p17845.hitmarker.isReady = true;
            p17845.hitmarker.image.src = p18005;
          } else {
            p17845.hitmarker.image = new Image();
            p17845.hitmarker.image.onload = () => p17845.hitmarker.isReady = true;
            p17845.hitmarker.image.src = p18005;
          }
          p17845.hitmarker.custom = false;
        } else if (p18005.length) {
          p17845.hitmarker.image = false;
          hitmarker.src = p18005;
          p17845.hitmarker.custom = true;
        } else {
          p17845.hitmarker.image = false;
          p17845.hitmarker.custom = false;
        }
      }
    },
    gpSetts: {
      name: "settings.gameplay.gpSetts",
      info: "Adjust settings for all weapons or specific weapons",
      cat: "gameplay",
      val: 0,
      options: {
        0: "All",
        1: "Per Weapon"
      },
      type: "select",
      set: function (p18006, p18007) {
        vThis142.tmp[this.key] = parseInt(p18006);
        p17840.gpSetts = parseInt(p18006);
        if (!p18007) {
          updateWindow(1);
        }
      }
    },
    sensitivityX: {
      name: "settings.gameplay.sensitivityX",
      info: "Adjust sensitivity for X mouse movement",
      cat: "gameplay",
      val: p17840.isMobile ? 1.4 : 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      perWepG: true,
      type: "slider",
      set: function (p18008) {
        vThis142.tmp[this.key] = p18008;
        p17840.kbmInput.sensX[this.weapon + 1] = p18008;
      }
    },
    sensitivityY: {
      name: "settings.gameplay.sensitivityY",
      info: "Adjust sensitivity for Y mouse movement",
      cat: "gameplay",
      val: p17840.isMobile ? 1.4 : 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      perWepG: true,
      type: "slider",
      set: function (p18009) {
        vThis142.tmp[this.key] = p18009;
        p17840.kbmInput.sensY[this.weapon + 1] = p18009;
      }
    },
    aimSensitivityX: {
      name: "settings.gameplay.aimsensX",
      info: "Adjust sensitivity for X aiming movement",
      cat: "gameplay",
      pro: 0.69,
      val: p17840.isMobile ? 1.4 : 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      perWepG: true,
      type: "slider",
      set: function (p18010) {
        vThis142.tmp[this.key] = p18010;
        p17840.kbmInput.aimX[this.weapon + 1] = p18010;
      }
    },
    aimSensitivityY: {
      name: "settings.gameplay.aimsensY",
      info: "Adjust sensitivity for Y aiming movement",
      cat: "gameplay",
      pro: 0.69,
      val: p17840.isMobile ? 1.4 : 1,
      min: 0.1,
      max: 15,
      step: 0.1,
      perWepG: true,
      type: "slider",
      set: function (p18011) {
        vThis142.tmp[this.key] = p18011;
        p17840.kbmInput.aimY[this.weapon + 1] = p18011;
      }
    },
    scrollDir: {
      name: "settings.gameplay.scrollDir",
      info: "Change scroll direction",
      cat: "gameplay",
      sType: "advanced",
      val: true,
      toggle: true,
      perWepG: true,
      type: "switch",
      set: function (p18012) {
        vThis142.tmp[this.key] = p18012 ? 1 : -1;
        p17840.kbmInput.scroll[this.weapon + 1] = p18012 ? 1 : -1;
      }
    },
    invertY: {
      name: "settings.gameplay.invert",
      info: "Invert Y-Axis for mouse movement",
      cat: "gameplay",
      sType: "advanced",
      val: false,
      toggle: true,
      perWepG: true,
      type: "switch",
      set: function (p18013) {
        vThis142.tmp[this.key] = p18013;
        p17840.kbmInput.invert[this.weapon + 1] = p18013;
      }
    },
    challMode: {
      name: "settings.gameplay.challenge",
      info: "Half HP and no health regeneration for more KR and XP. Level 30 required",
      cat: "gameplay",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p18014) {
        vThis142.tmp[this.key] = p18014;
        window.toggleChal(p18014);
      }
    },
    disableCons: {
      name: "settings.controller.disableCons",
      info: "Prevents input from controller",
      cat: "controller",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p18015) {
        vThis142.tmp[this.key] = !!p18015;
        p17840.toggleGamepad(vThis142.tmp[this.key]);
      }
    },
    sensitivityXCntrl: {
      name: "settings.controller.sensitivityX",
      info: "Adjust sensitivity for X thumbstick movement",
      cat: "controller",
      val: 4,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (p18016) {
        vThis142.tmp[this.key] = p18016 * 5;
        p17840.cntrlInput.sensX = p18016 * 5;
      }
    },
    sensitivityYCntrl: {
      name: "settings.controller.sensitivityY",
      info: "Adjust sensitivity for Y thumbstick movement",
      cat: "controller",
      val: 4,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (p18017) {
        vThis142.tmp[this.key] = p18017 * 5;
        p17840.cntrlInput.sensY = p18017 * 5;
      }
    },
    aimSensitivityXCntrl: {
      name: "settings.controller.aimsensX",
      info: "Adjust sensitivity for X thumbstick aim movement",
      cat: "controller",
      val: 3,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (p18018) {
        vThis142.tmp[this.key] = p18018 * 5;
        p17840.cntrlInput.aimX = p18018 * 5;
      }
    },
    aimSensitivityYCntrl: {
      name: "settings.controller.aimsensY",
      info: "Adjust sensitivity for Y thumbstick aim movement",
      cat: "controller",
      val: 3,
      min: 0.1,
      max: 15,
      step: 0.1,
      type: "slider",
      set: function (p18019) {
        vThis142.tmp[this.key] = p18019 * 5;
        p17840.cntrlInput.aimY = p18019 * 5;
      }
    },
    deadZoneL: {
      name: "settings.controller.deadZoneL",
      info: "Prevent input until certain value is reached - Left",
      cat: "controller",
      val: 0.3,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (p18020) {
        vThis142.tmp[this.key] = p18020;
        p17840.cntrlInput.deadZoneL = p18020;
      }
    },
    deadZoneR: {
      name: "settings.controller.deadZoneR",
      info: "Prevent input until certain value is reached - Right",
      cat: "controller",
      val: 0.25,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (p18021) {
        vThis142.tmp[this.key] = p18021;
        p17840.cntrlInput.deadZoneR = p18021;
      }
    },
    triggerThres: {
      name: "settings.controller.triggerThres",
      info: "Trigger cannot fire until this threshold is met",
      cat: "controller",
      val: 0.1,
      min: 0,
      max: 1,
      step: 0.05,
      type: "slider",
      set: function (p18022) {
        vThis142.tmp[this.key] = p18022;
        p17840.cntrlInput.triggerThres = p18022;
      }
    },
    invertYCntrl: {
      name: "settings.controller.invert",
      info: "Invert Y-Axis for controller aim movement",
      cat: "controller",
      val: false,
      type: "switch",
      set: function (p18023) {
        vThis142.tmp[this.key] = p18023;
        p17840.cntrlInput.invert = p18023;
      }
    },
    vibrationMlt: {
      name: "settings.controller.vibration",
      info: "Strength of controller vibration",
      cat: "controller",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      style: "width: 244px;",
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.vibration) + p17843._html.settings.input.slider(this);
      },
      set: function (p18024) {
        vThis142.tmp[this.key] = parseInt(p18024);
        p17840.cntrlInput.vibrationMlt = p18024;
      }
    },
    vibration: {
      name: "settings.controller.vibration",
      info: "Toggle controller vibration",
      cat: "controller",
      val: true,
      hide: true,
      html: function () {},
      set: function (p18025) {
        vThis142.tmp[this.key] = p18025;
        p17840.cntrlInput.vibration = p18025;
      }
    },
    gradSpeed: {
      name: "settings.controller.gradSpeed",
      cat: "controller",
      val: false,
      type: "switch",
      set: function (p18026) {
        vThis142.tmp[this.key] = p18026;
        p17840.cntrlInput.gradSpeed = p18026;
        p17840.speedLmt = 1;
      }
    },
    sensitivityXMbl: {
      name: "settings.mobile.sensitivityX",
      cat: "mobile",
      mobileFriendly: true,
      val: 1.4,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !p17840.isMobile,
      type: "slider",
      set: function (p18027) {
        vThis142.tmp[this.key] = p18027 * 4;
        p17840.mblInput.sensX = p18027 * 4;
      }
    },
    sensitivityYMbl: {
      name: "settings.mobile.sensitivityY",
      cat: "mobile",
      mobileFriendly: true,
      val: 1.4,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !p17840.isMobile,
      type: "slider",
      set: function (p18028) {
        vThis142.tmp[this.key] = p18028 * 4;
        p17840.mblInput.sensY = p18028 * 4;
      }
    },
    aimSensitivityXMbl: {
      name: "settings.mobile.aimsensX",
      cat: "mobile",
      mobileFriendly: true,
      val: 1.4,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !p17840.isMobile,
      type: "slider",
      set: function (p18029) {
        vThis142.tmp[this.key] = p18029 * 4;
        p17840.mblInput.aimX = p18029 * 4;
      }
    },
    aimSensitivityYMbl: {
      name: "settings.mobile.aimsensY",
      cat: "mobile",
      mobileFriendly: true,
      val: 1.4,
      min: 0.1,
      max: 15,
      step: 0.1,
      hide: !p17840.isMobile,
      type: "slider",
      set: function (p18030) {
        vThis142.tmp[this.key] = p18030 * 4;
        p17840.mblInput.aimY = p18030 * 4;
      }
    },
    invertYMbl: {
      name: "settings.mobile.invert",
      cat: "mobile",
      mobileFriendly: true,
      val: false,
      hide: !p17840.isMobile,
      type: "switch",
      set: function (p18031) {
        vThis142.tmp[this.key] = p18031;
        p17840.mblInput.invert = p18031;
      }
    },
    vibrationMbl: {
      name: "settings.mobile.vibration",
      cat: "mobile",
      mobileFriendly: true,
      val: true,
      hide: !p17840.isMobile,
      type: "switch",
      set: function (p18032) {
        vThis142.tmp[this.key] = p18032;
        p17840.mblInput.vibration = p18032;
      }
    },
    gradSpeedMbl: {
      name: "settings.mobile.gradSpeed",
      cat: "mobile",
      mobileFriendly: true,
      val: true,
      hide: !p17840.isMobile,
      type: "switch",
      set: function (p18033) {
        vThis142.tmp[this.key] = p18033;
        p17840.mblInput.gradSpeed = p18033;
        p17840.speedLmt = 1;
      }
    },
    sound: {
      name: "settings.audio.sound",
      info: "Adjust all sound",
      cat: "audio",
      mobileFriendly: true,
      pro: 0.1,
      perf: 0.1,
      val: 0.8,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18034) {
        vThis142.tmp[this.key] = p18034;
        SOUND.setVolume(p18034, 0);
      }
    },
    ambientVolume: {
      name: "settings.audio.ambient",
      info: "Background sound volume",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18035) {
        vThis142.tmp[this.key] = p18035;
        SOUND.setVolume(p18035, 2);
      }
    },
    dialogueVolume: {
      name: "settings.audio.dialogue",
      info: "Audio performed on action",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18036) {
        vThis142.tmp[this.key] = p18036;
        SOUND.setVolume(p18036, 7);
      }
    },
    audioInput: {
      name: "settings.audio.input",
      info: "Select hardware device for audio/microphone",
      cat: "audio",
      val: "default",
      options: {
        default: "Default"
      },
      type: "select",
      set: function (p18037) {
        vThis142.tmp[this.key] = p18037;
        window.updateAudioInputs();
      }
    },
    micQuality: {
      name: "settings.audio.micquality",
      info: "Quality of in-game voice chat",
      cat: "audio",
      val: 6000,
      options: {
        3000: "Low",
        6000: "Medium",
        9000: "High",
        12000: "Epic",
        15000: "Ultra"
      },
      type: "select",
      set: function (p18038) {
        vThis142.tmp[this.key] = p18038;
      }
    },
    micVolume: {
      name: "settings.audio.mic",
      info: "Volume of emitted voice chat",
      cat: "audio",
      pro: 0,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18039) {
        vThis142.tmp[this.key] = p18039;
      }
    },
    voiceVolume: {
      name: "settings.audio.voice",
      info: "Voice chat volume",
      cat: "audio",
      pro: 0,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18040) {
        vThis142.tmp[this.key] = p18040;
        SOUND.setVolume(p18040, 1);
      }
    },
    voiceChatType: {
      name: "settings.audio.voice.type",
      info: "Voice chat type",
      cat: "audio",
      val: 0,
      options: {
        0: "Default",
        1: "Spacial / Proximity"
      },
      type: "select",
      set: function (p18041) {
        vThis142.tmp[this.key] = parseInt(p18041) || 0;
        vThis142.list.voiceDistance.hide = p18041 == 0;
        let v13938 = document.getElementById("voiceDistance_div");
        if (v13938) {
          v13938.style.display = vThis142.list.voiceDistance.hide ? "none" : "block";
        }
      }
    },
    voiceDistance: {
      name: "settings.audio.voice.dist",
      info: "Voice chat distance when using spacial",
      cat: "audio",
      val: 5,
      min: 1,
      max: 10,
      step: 1,
      type: "slider",
      hide: true,
      set: function (p18042) {
        vThis142.tmp[this.key] = (parseInt(p18042) || 1) * 5;
      }
    },
    gunsVolume: {
      name: "settings.audio.weps",
      info: "Sound emitted from weapons (reloading, firing, etc)",
      cat: "audio",
      mobileFriendly: true,
      val: 0.3,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18043) {
        vThis142.tmp[this.key] = p18043;
        SOUND.setVolume(p18043, 3);
      }
    },
    playerVolume: {
      name: "settings.audio.player",
      info: "Sound emitted from players (jumping, sliding, etc)",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18044) {
        vThis142.tmp[this.key] = p18044;
        SOUND.setVolume(p18044, 4);
      }
    },
    skinVolume: {
      name: "settings.audio.skin",
      info: "Sound emitted from skins",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18045) {
        vThis142.tmp[this.key] = p18045;
        SOUND.setVolume(p18045, 8);
      }
    },
    uiVolume: {
      name: "settings.audio.ui",
      info: "Menu interface volume",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18046) {
        vThis142.tmp[this.key] = p18046;
        SOUND.setVolume(p18046, 5);
      }
    },
    assetVolume: {
      name: "settings.audio.asset",
      info: "Sound emitted from in-game assets",
      cat: "audio",
      mobileFriendly: true,
      val: 1,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18047) {
        vThis142.tmp[this.key] = p18047;
        SOUND.setVolume(p18047, 6);
      }
    },
    muteSpec: {
      name: "settings.audio.mute.spec",
      info: "Mute Spectators",
      cat: "audio",
      val: false,
      toggle: true,
      noMod: true,
      type: "switch",
      set: function (p18048) {
        vThis142.tmp[this.key] = p18048;
      }
    },
    streamMode: {
      name: "settings.gameprivacy.streamer",
      info: "Hide sensitive data. Prevents \"Stream-sniping\"",
      cat: "gameprivacy",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p18049, p18050) {
        vThis142.tmp[this.key] = !!p18049;
        p17845.hideNames = p18049;
        if (!p18050) {
          window.toggleStrm(p18049);
        }
      }
    },
    anonMode: {
      name: "settings.gameprivacy.anon",
      info: "Hides usernames in-game. Verification required",
      cat: "gameprivacy",
      val: false,
      verified: true,
      toggle: true,
      noMod: true,
      type: "switch",
      set: function (p18051) {
        vThis142.tmp[this.key] = p18051;
      }
    },
    hideGameP: {
      name: "settings.gameprivacy.hideGameTitle",
      cat: "gameprivacy",
      val: "",
      placeholder: "Custom Title",
      type: "text",
      set: function (p18052) {
        vThis142.tmp[this.key] = p18052;
      }
    },
    showRegion: {
      name: "settings.gameprivacy.showRegion",
      info: "Hide all region information",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      noMod: true,
      type: "switch",
      set: function (p18053) {
        vThis142.tmp[this.key] = p18053;
        menuRegionLabel.style.display = p18053 ? "flex" : "none";
      }
    },
    showServerTimer: {
      name: "settings.gameprivacy.showServerTimer",
      info: "Show server timers",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      noMod: true,
      type: "switch",
      set: function (p18054) {
        vThis142.tmp[this.key] = p18054;
      }
    },
    verifiedBadge: {
      name: "settings.gameprivacy.verified",
      info: "Display verified badge in-game. Verification required",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      verified: true,
      noMod: true,
      type: "switch",
      set: function (p18055) {
        vThis142.tmp[this.key] = p18055;
        if (window && window.refreshMenuAcc) {
          window.refreshMenuAcc();
        }
      }
    },
    premiumBadge: {
      name: "settings.gameprivacy.premium",
      info: "Display premium badge in-game. Premium required",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      premium: true,
      noMod: true,
      type: "switch",
      set: function (p18056) {
        vThis142.tmp[this.key] = p18056;
        if (window && window.refreshMenuAcc) {
          window.refreshMenuAcc();
        }
      }
    },
    partnerBadge: {
      name: "settings.gameprivacy.partner",
      info: "Display partner badge in-game. Partner required",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      partner: true,
      noMod: true,
      type: "switch",
      set: function (p18057) {
        vThis142.tmp[this.key] = p18057;
        if (window && window.refreshMenuAcc) {
          window.refreshMenuAcc();
        }
      }
    },
    customBadge: {
      name: "settings.gameprivacy.custom",
      cat: "gameprivacy",
      val: true,
      toggle: true,
      noMod: true,
      type: "switch",
      set: function (p18058) {
        vThis142.tmp[this.key] = p18058;
        if (window && window.refreshMenuAcc) {
          window.refreshMenuAcc();
        }
      }
    },
    vmSetts: {
      name: "settings.viewmodel.vmSetts",
      info: "Weapon model display for all weapons or specific weapons",
      cat: "viewmodel",
      val: 0,
      options: {
        0: "All",
        1: "Per Weapon"
      },
      type: "select",
      set: function (p18059, p18060) {
        vThis142.tmp[this.key] = parseInt(p18059);
        p17838.vmSetts = parseInt(p18059);
        if (!p18060) {
          updateWindow(1);
        }
      }
    },
    fov: {
      name: "settings.viewmodel.fov",
      cat: "viewmodel",
      mobileFriendly: true,
      pro: 110,
      val: config.fov + 20,
      min: 60,
      max: 150,
      step: 5,
      perWep: true,
      type: "slider",
      set: function (p18061) {
        vThis142.tmp[this.key] = p18061;
        updateFov(0, p18061, this.weapon);
      }
    },
    fpsFOV: {
      name: "settings.viewmodel.fps",
      cat: "viewmodel",
      mobileFriendly: true,
      pro: 105,
      val: config.fov + 15,
      min: 60,
      max: 150,
      step: 5,
      perWep: true,
      type: "slider",
      set: function (p18062) {
        vThis142.tmp[this.key] = p18062;
        updateFov(1, p18062, this.weapon);
      }
    },
    weaponBob: {
      name: "settings.viewmodel.bobbing",
      info: "Animates weapon left to right on movement",
      cat: "viewmodel",
      sType: "advanced",
      pro: 0.2,
      perf: 0,
      val: 0.7,
      min: 0,
      max: 3,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18063) {
        vThis142.tmp[this.key] = p18063;
        p17838.weaponBob[this.weapon + 1] = p18063;
      }
    },
    weaponLean: {
      name: "settings.viewmodel.leaning",
      info: "Temporarily lean weapon toward the direction of mouse movement",
      cat: "viewmodel",
      sType: "advanced",
      pro: 2,
      perf: 0,
      val: 0.6,
      min: 0,
      max: 6,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18064) {
        vThis142.tmp[this.key] = p18064;
        p17838.weaponLean[this.weapon + 1] = p18064;
      }
    },
    weaponRot: {
      name: "settings.viewmodel.rot",
      info: "Rotate weapon",
      cat: "viewmodel",
      sType: "advanced",
      pro: 0,
      val: 0,
      min: -2,
      max: 2,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18065) {
        vThis142.tmp[this.key] = p18065;
        p17838.weaponRot[this.weapon + 1] = p18065;
      }
    },
    weaponOffX: {
      name: "settings.viewmodel.xOff",
      info: "Move weapon model left or right",
      cat: "viewmodel",
      sType: "advanced",
      pro: 1.4,
      val: 1,
      min: 0,
      max: 4,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18066) {
        vThis142.tmp[this.key] = p18066;
        p17838.weaponOffX[this.weapon + 1] = p18066;
      }
    },
    weaponOffY: {
      name: "settings.viewmodel.yOff",
      info: "Move weapon model up or down",
      cat: "viewmodel",
      sType: "advanced",
      pro: 2,
      val: 1.3,
      min: 0,
      max: 4,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18067) {
        vThis142.tmp[this.key] = p18067;
        p17838.weaponOffY[this.weapon + 1] = p18067;
      }
    },
    weaponOffZ: {
      name: "settings.viewmodel.zOff",
      info: "Move weapon model forwards or backwards",
      cat: "viewmodel",
      sType: "advanced",
      pro: 1.5,
      val: 1,
      min: 0,
      max: 4,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18068) {
        vThis142.tmp[this.key] = p18068;
        p17838.weaponOffZ[this.weapon + 1] = p18068;
      }
    },
    weaponADSOffY: {
      name: "settings.viewmodel.yOffADS",
      info: "Move weapon model up or down while aiming",
      cat: "viewmodel",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 2,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18069) {
        vThis142.tmp[this.key] = p18069;
        p17838.weaponADSOffY[this.weapon + 1] = p18069;
      }
    },
    weapSwapY: {
      name: "settings.viewmodel.weapSwapY",
      info: "Move weapon swap location up or down",
      cat: "viewmodel",
      sType: "advanced",
      val: 1,
      min: -2,
      max: 2,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18070) {
        vThis142.tmp[this.key] = p18070;
        p17838.weapSwapY[this.weapon + 1] = p18070;
      }
    },
    weapReloadY: {
      name: "settings.viewmodel.weapReloadY",
      info: "How far weapon lowers while reloading",
      cat: "viewmodel",
      sType: "advanced",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18071) {
        vThis142.tmp[this.key] = p18071;
        p17838.weapReloadY[this.weapon + 1] = p18071;
      }
    },
    adsFovMlt: {
      name: "settings.viewmodel.adsFovMlt",
      info: "Change FOV while aiming down sight",
      cat: "viewmodel",
      sType: "advanced",
      val: 1,
      min: 0.3,
      max: 1,
      step: 0.1,
      perWep: true,
      type: "slider",
      set: function (p18072) {
        vThis142.tmp[this.key] = p18072;
        p17838.adsFov[this.weapon + 1] = p18072;
      }
    },
    toggleADS: {
      name: "settings.viewmodel.toggleADS",
      info: "Toggle aim down sight",
      cat: "viewmodel",
      val: false,
      toggle: true,
      perWep: true,
      type: "switch",
      set: function (p18073) {
        vThis142.tmp[this.key] = p18073;
        p17840.toggleADS[this.weapon + 1] = p18073;
      }
    },
    aimAnim: {
      name: "settings.viewmodel.aimAnim",
      info: "Show weapon animation while aiming down sight",
      cat: "viewmodel",
      sType: "advanced",
      perf: false,
      val: true,
      toggle: true,
      perWep: true,
      type: "switch",
      set: function (p18074) {
        vThis142.tmp[this.key] = p18074;
        p17838.aimAnim[this.weapon + 1] = p18074;
      }
    },
    hideADS: {
      name: "settings.viewmodel.show.ads",
      info: "Remove weapon model while aiming down sight",
      cat: "viewmodel",
      sType: "advanced",
      pro: true,
      perf: true,
      val: false,
      toggle: true,
      perWep: true,
      type: "switch",
      set: function (p18075) {
        vThis142.tmp[this.key] = p18075;
        p17838.hideADS[this.weapon + 1] = p18075;
      }
    },
    showHands: {
      name: "settings.viewmodel.show.hands",
      info: "Display hand models",
      cat: "viewmodel",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18076) {
        vThis142.tmp[this.key] = p18076;
        p17838.showHands = p18076;
        window.updateWeaponShow(0, p18076);
      }
    },
    showWeapon: {
      name: "settings.viewmodel.show.primary",
      info: "Display primary weapon model",
      cat: "viewmodel",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18077) {
        vThis142.tmp[this.key] = p18077;
        p17841.hideWeapon[0] = !p18077;
        window.updateWeaponShow(1, p18077);
      }
    },
    showWeaponSec: {
      name: "settings.viewmodel.show.secondary",
      info: "Display secondary weapon model",
      cat: "viewmodel",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18078) {
        vThis142.tmp[this.key] = p18078;
        p17841.hideWeapon[1] = !p18078;
        window.updateWeaponShow(2, p18078);
      }
    },
    showWeaponMel: {
      name: "settings.viewmodel.show.melee",
      info: "Display melee model",
      cat: "viewmodel",
      sType: "advanced",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18079) {
        vThis142.tmp[this.key] = p18079;
        p17841.hideWeapon[2] = !p18079;
        window.updateWeaponShow(3, p18079);
      }
    },
    leftHand: {
      name: "settings.viewmodel.leftHand",
      info: "Swap weapon location to left hand",
      cat: "viewmodel",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p18080) {
        vThis142.tmp[this.key] = p18080;
        p17838.leftHand = p18080;
      }
    },
    roundArms: {
      name: "settings.viewmodel.roundArms",
      info: "Use rounded arm models",
      cat: "viewmodel",
      sType: "advanced",
      val: false,
      toggle: true,
      type: "switch",
      needsRestart: true,
      info: "Requires Restart",
      set: function (p18081) {
        vThis142.tmp[this.key] = !!p18081;
        p17838.roundArms = !!p18081;
      }
    },
    wallLeanMlt: {
      name: "settings.viewmodel.wallLeanMlt",
      cat: "viewmodel",
      sType: "advanced",
      val: 0.5,
      min: 0,
      max: 1,
      step: 0.1,
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.wallLean) + p17843._html.settings.input.slider(this);
      },
      set: function (p18082) {
        vThis142.tmp[this.key] = parseFloat(p18082);
      }
    },
    wallLean: {
      name: "settings.viewmodel.wallLean",
      cat: "viewmodel",
      sType: "advanced",
      val: false,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p18083) {
        vThis142.tmp[this.key] = !!p18083;
      }
    },
    hudHealthHigh: {
      name: "settings.editing.health.high",
      info: "HUD health bar color - Max HP",
      cat: "editing",
      val: COLORS.hudHealth.high,
      color: true,
      type: "color",
      set: function (p18084) {
        vThis142.tmp[this.key] = p18084;
      }
    },
    hudHealthLow: {
      name: "settings.editing.health.low",
      info: "HUD health bar color - Below max HP",
      cat: "editing",
      val: COLORS.hudHealth.low,
      color: true,
      type: "color",
      set: function (p18085) {
        vThis142.tmp[this.key] = p18085;
      }
    },
    showSpdLines: {
      name: "settings.editing.speedLines",
      info: "Display lines on-screen while moving fast",
      cat: "editing",
      perf: 0,
      val: 0,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18086) {
        vThis142.tmp[this.key] = p18086;
        p17845.shoSpdLines = p18086;
      }
    },
    spdLinesCol: {
      name: "settings.editing.spdLinesCol",
      info: "Speed lines color",
      cat: "editing",
      val: "#e6e6e6",
      color: true,
      type: "color",
      set: function (p18087) {
        vThis142.tmp[this.key] = UTILS.hexToRGB(p18087).join(",");
        p17845.spdLinesCol = UTILS.hexToRGB(p18087).join(",");
      }
    },
    showPScore: {
      name: "settings.editing.score.show",
      info: "Score displayed after completing objective, killing opponent, etc",
      cat: "editing",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18088) {
        vThis142.tmp[this.key] = !p18088;
        p17845.scoreText.disabled = !p18088;
      }
    },
    scoreColor: {
      name: "settings.editing.score.color",
      info: "Score color",
      cat: "editing",
      val: COLORS.popupScore,
      color: true,
      type: "color",
      set: function (p18089) {
        vThis142.tmp[this.key] = p18089;
        p17845.scoreText.color = p18089;
      }
    },
    scoreShadow: {
      name: "settings.editing.score.shadow",
      info: "Use shadow on score",
      cat: "editing",
      val: false,
      toggle: true,
      type: "switch",
      set: function (p18090) {
        vThis142.tmp[this.key] = p18090 ? 3 : 0;
        p17845.scoreText.shadow = p18090 ? 3 : 0;
      }
    },
    scoreScale: {
      name: "settings.editing.score.scale",
      info: "Increase score font-size",
      cat: "editing",
      pro: 0.6,
      val: 1,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p18091) {
        vThis142.tmp[this.key] = p18091 || 1;
      }
    },
    scoreOffX: {
      name: "settings.editing.scoreOffX",
      info: "Move score popup left or right",
      cat: "editing",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18092) {
        vThis142.tmp[this.key] = p18092 * 10;
        p17845.scoreText.left = p18092 * 10;
      }
    },
    scoreOffY: {
      name: "settings.editing.scoreOffY",
      info: "Move score popup up or down",
      cat: "editing",
      pro: 2.5,
      val: 3.7,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18093) {
        vThis142.tmp[this.key] = p18093 * 10;
        p17845.scoreText.top = p18093 * 10;
      }
    },
    progColor: {
      name: "settings.editing.prog.color",
      cat: "editing",
      val: "#ffffff",
      color: true,
      type: "color",
      set: function (p18094) {
        vThis142.tmp[this.key] = p18094;
        p17845.interactProg.color = p18094;
      }
    },
    progOpac: {
      name: "settings.editing.prog.opacity",
      cat: "editing",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18095) {
        vThis142.tmp[this.key] = p18095;
        p17845.interactProg.opacity = p18095;
      }
    },
    progShadow: {
      name: "settings.editing.prog.shadow",
      cat: "editing",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18096) {
        vThis142.tmp[this.key] = !!p18096;
        p17845.interactProg.shadow = !!p18096;
      }
    },
    progScale: {
      name: "settings.editing.prog.scale",
      cat: "editing",
      val: 1,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p18097) {
        vThis142.tmp[this.key] = p18097 || 1;
        p17845.interactProg.scale = p18097 || 1;
      }
    },
    progOffX: {
      name: "settings.editing.progOffX",
      cat: "editing",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18098) {
        vThis142.tmp[this.key] = p18098 * 10;
        p17845.interactProg.left = p18098 * 10;
      }
    },
    progOffY: {
      name: "settings.editing.progOffY",
      cat: "editing",
      val: 7.2,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18099) {
        vThis142.tmp[this.key] = p18099 * 10;
        p17845.interactProg.top = p18099 * 10;
      }
    },
    progRot: {
      name: "settings.editing.progRot",
      cat: "editing",
      val: 0,
      min: 0,
      max: 360,
      step: 1,
      type: "slider",
      set: function (p18100) {
        vThis142.tmp[this.key] = UTILS.toRad(p18100);
        p17845.interactProg.rot = UTILS.toRad(p18100);
      }
    },
    progMColor: {
      name: "settings.editing.progm.color",
      info: "Color used while charging weapon (crossbow, melee, etc)",
      cat: "editing",
      val: "#ffffff",
      color: true,
      type: "color",
      set: function (p18101) {
        vThis142.tmp[this.key] = p18101;
        p17845.interactMProg.color = p18101;
      }
    },
    progMOColor: {
      name: "settings.editing.progmo.color",
      info: "Color displayed when weapon is overcharged",
      cat: "editing",
      val: "#eb2f2f",
      color: true,
      type: "color",
      set: function (p18102) {
        vThis142.tmp[this.key] = p18102;
        p17845.interactMProg.oColor = p18102;
      }
    },
    progMOpac: {
      name: "settings.editing.progm.opacity",
      info: "Weapon charge display opacity",
      cat: "editing",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18103) {
        vThis142.tmp[this.key] = p18103;
        p17845.interactMProg.opacity = p18103;
      }
    },
    progMShadow: {
      name: "settings.editing.progm.shadow",
      info: "Weapon charge display shadow",
      cat: "editing",
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18104) {
        vThis142.tmp[this.key] = !!p18104;
        p17845.interactMProg.shadow = !!p18104;
      }
    },
    progMScale: {
      name: "settings.editing.progm.scale",
      info: "Weapon charge display size",
      cat: "editing",
      val: 0.5,
      min: 0.1,
      max: 2,
      step: 0.1,
      type: "slider",
      set: function (p18105) {
        vThis142.tmp[this.key] = p18105 || 1;
        p17845.interactMProg.scale = p18105 || 1;
      }
    },
    progMOffX: {
      name: "settings.editing.progmOffX",
      info: "Move weapon charge display left or right",
      cat: "editing",
      val: 5.6,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18106) {
        vThis142.tmp[this.key] = p18106 * 10;
        p17845.interactMProg.left = p18106 * 10;
      }
    },
    progMOffY: {
      name: "settings.editing.progmOffY",
      info: "Move weapon charge display up or down",
      cat: "editing",
      val: 5,
      min: 0,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18107) {
        vThis142.tmp[this.key] = p18107 * 10;
        p17845.interactMProg.top = p18107 * 10;
      }
    },
    progMRot: {
      name: "settings.editing.progmRot",
      info: "Rotate weapon charge display",
      cat: "editing",
      val: 270,
      min: 0,
      max: 360,
      step: 1,
      type: "slider",
      set: function (p18108) {
        vThis142.tmp[this.key] = UTILS.toRad(p18108);
        p17845.interactMProg.rot = UTILS.toRad(p18108);
      }
    },
    saturationn: {
      name: "settings.editing.saturation",
      info: "Increase color saturation in-game",
      cat: "editing",
      mobileFriendly: true,
      val: 1,
      perf: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function (p18109) {
        vThis142.tmp[this.key] = p18109;
        window.bundleFilters(0);
      }
    },
    menuSaturation: {
      name: "settings.editing.menuSaturation",
      info: "Increase color saturation for menu",
      cat: "editing",
      pro: 1,
      val: 1,
      min: 0,
      max: 3,
      step: 0.1,
      type: "slider",
      set: function (p18110) {
        vThis142.tmp[this.key] = p18110;
        window.bundleFilters(1);
      }
    },
    hue: {
      name: "settings.editing.hue",
      info: "Shift colors in-game",
      cat: "editing",
      val: 0,
      min: 0,
      max: 100,
      step: 5,
      type: "slider",
      set: function (p18111) {
        vThis142.tmp[this.key] = p18111;
        window.bundleFilters(0);
      }
    },
    menuHue: {
      name: "settings.editing.menuHue",
      info: "Shift colors in-menu",
      cat: "editing",
      val: 0,
      min: 0,
      max: 100,
      step: 5,
      type: "slider",
      set: function (p18112) {
        vThis142.tmp[this.key] = p18112;
        window.bundleFilters(1);
      }
    },
    vignette: {
      name: "settings.editing.vignette",
      info: "Add shadow around HUD",
      cat: "editing",
      val: 0,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18113) {
        if (p18113 == 1) {
          vignette.style.removeProperty("opacity");
        } else {
          vignette.style.opacity = p18113;
        }
        vThis142.tmp[this.key] = p18113;
      }
    },
    feedLimit: {
      name: "settings.editing.feedLimit",
      info: "Amount of killfeed entries displayed",
      cat: "editing",
      pro: 4,
      val: 8,
      min: 1,
      max: 10,
      step: 1,
      type: "slider",
      set: function (p18114) {
        vThis142.tmp[this.key] = p18114;
        window.refreshFeed(p18114);
      }
    },
    bulletTracers: {
      name: "settings.editing.tracer",
      info: "Toggle bullet tracers",
      cat: "editing",
      perf: false,
      val: true,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p18115) {
        vThis142.tmp[this.key] = p18115;
        p17839.showTracers = p18115;
      }
    },
    bulletTracerCol: {
      name: "settings.editing.tracercol",
      info: "Change bullet tracer color",
      cat: "editing",
      val: "#ffffdb",
      color: true,
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.bulletTracers) + p17843._html.settings.input.color(this);
      },
      set: function (p18116) {
        vThis142.tmp[this.key] = p18116;
        p17839.setTracerColor(p18116);
      }
    },
    tracerOffset: {
      name: "settings.editing.tracer.offset",
      cat: "editing",
      val: 0,
      min: 0,
      max: 1,
      step: 0.01,
      type: "slider",
      set: function (p18117) {
        vThis142.tmp[this.key] = p18117 || 0;
        p17838.tracerOffset = p18117 || 0;
      }
    },
    trailCol: {
      name: "settings.editing.trailcol",
      info: "Bullet trail color",
      cat: "editing",
      val: "#ededed",
      color: true,
      type: "color",
      set: function (p18118) {
        vThis142.tmp[this.key] = p18118;
        p17838.trailColor = p18118;
      }
    },
    ropeCol: {
      name: "settings.editing.ropecol",
      info: "Grapple rope color",
      cat: "editing",
      val: "#b3b3b3",
      color: true,
      type: "color",
      set: function (p18119) {
        vThis142.tmp[this.key] = p18119;
        p17838.ropeColor = p18119;
      }
    },
    canLoadMods: {
      name: "settings.mods.load",
      info: "Allow mods to be loaded",
      cat: "mods",
      noMod: true,
      val: true,
      type: "switch",
      set: function (p18120) {
        vThis142.tmp[this.key] = p18120;
      }
    },
    canChangeLogo: {
      name: "settings.mods.logo",
      info: "Allow loaded mod to adjust menu logo",
      cat: "mods",
      noMod: true,
      val: true,
      type: "switch",
      set: function (p18121) {
        vThis142.tmp[this.key] = p18121;
      }
    },
    autoLoadLast: {
      name: "settings.mods.auto",
      info: "Automatically load last used mod",
      cat: "mods",
      noMod: true,
      val: false,
      type: "switch",
      set: function (p18122) {
        vThis142.tmp[this.key] = p18122;
      }
    },
    scopeBorderCol: {
      name: "settings.mods.borderCol",
      info: "Adjust scope border color",
      cat: "mods",
      val: "#000000",
      color: true,
      html: function () {
        return p17843._html.settings.input.switch(vThis142.list.scopeBorders) + p17843._html.settings.input.color(this);
      },
      set: function (p18123) {
        vThis142.tmp[this.key] = p18123;
        p17845.scopeBorders.color = p18123;
        Array.from(document.querySelectorAll(".black")).forEach(p18124 => p18124.style.backgroundColor = p18123);
      }
    },
    scopeBorders: {
      name: "settings.mods.borders",
      info: "Scope border opacity",
      cat: "mods",
      pro: true,
      val: true,
      hide: true,
      toggle: true,
      html: function () {},
      set: function (p18125) {
        vThis142.tmp[this.key] = !!p18125;
        p17845.scopeBorders.display = !!p18125;
        Array.from(document.querySelectorAll(".black")).forEach(p18126 => p18126.style.display = p18125 ? "block" : "none");
      }
    },
    scopeBorderOpac: {
      name: "settings.mods.borderOpac",
      info: "Adjust scope border opacity while aiming down sight",
      cat: "mods",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18127) {
        vThis142.tmp[this.key] = p18127;
        p17845.scopeBorders.opacity = p18127;
        Array.from(document.querySelectorAll(".black")).forEach(p18128 => p18128.style.opacity = p18127);
      }
    },
    scopeWidth: {
      name: "settings.mods.scope.width",
      info: "Adjust scope width",
      cat: "mods",
      val: 6.8,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18129) {
        p18129 *= 100;
        vThis142.tmp[this.key] = p18129;
        p17838.aimRecticle.width = p18129;
        recticleImg.style.width = p18129 + "px";
        var v13939 = Math.floor(p18129 / 2);
        var v13940 = Math.abs(v13939) % 2 == 1 && v13939 > 0 ? v13939 - 1 : v13939;
        leftBox.style.right = "calc(50% + " + v13940 + "px)";
        rightBox.style.left = "calc(50% + " + v13940 + "px)";
      }
    },
    scopeHeight: {
      name: "settings.mods.scope.height",
      info: "Adjust scope height",
      cat: "mods",
      val: 6.8,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18130) {
        p18130 *= 100;
        vThis142.tmp[this.key] = p18130;
        p17838.aimRecticle.height = p18130;
        recticleImg.style.height = p18130 + "px";
        var v13941 = Math.floor(p18130 / 2);
        var v13942 = Math.abs(v13941) % 2 == 1 && v13941 > 0 ? v13941 - 1 : v13941;
        topBox.style.top = "calc(50% + " + v13942 + "px)";
        bottomBox.style.bottom = "calc(50% + " + v13942 + "px)";
      }
    },
    scopeOpac: {
      name: "settings.mods.scope.opacity",
      info: "Scope opacity while aiming down sight",
      cat: "mods",
      val: 1,
      min: 0,
      max: 1,
      step: 0.1,
      type: "slider",
      set: function (p18131) {
        vThis142.tmp[this.key] = p18131;
        p17838.aimRecticle.opacMlt = p18131;
      }
    },
    reticleWidth: {
      name: "settings.mods.dot.width",
      info: "Adjust custom reticle width",
      cat: "mods",
      val: 2,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18132) {
        vThis142.tmp[this.key] = p18132 * 10;
        p17838.aimDot.width = p18132 * 10;
        aimDot.style.width = p18132 * 10 + "px";
      }
    },
    reticleHeight: {
      name: "settings.mods.dot.height",
      info: "Adjust custom reticle height",
      cat: "mods",
      val: 2,
      min: 0.1,
      max: 10,
      step: 0.1,
      type: "slider",
      set: function (p18133) {
        vThis142.tmp[this.key] = p18133 * 10;
        p17838.aimDot.height = p18133 * 10;
        aimDot.style.height = p18133 * 10 + "px";
      }
    },
    endMessage: {
      name: "settings.mods.endmessage",
      info: "Automatically send a message when match ends",
      cat: "mods",
      val: "",
      str: true,
      placeholder: p17847.t("settings.mods.endmessage"),
      type: "text",
      set: function (p18134) {
        vThis142.tmp[this.key] = p18134;
      }
    },
    customAmmo: {
      name: "settings.mods.ammo",
      info: "Replace default ammo icon",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.ammo.paste"),
      type: "url",
      collection: true,
      set: function (p18135) {
        p18135 = UTILS.isURL(p18135) && !/\.svg/.test(p18135) ? p18135 : "";
        ammoIcon.src = p18135.length > 1 ? p18135 : UTILS.assetsUrl("/textures/ammo_0.png");
      }
    },
    customKills: {
      name: "settings.mods.kills",
      info: "Replace default kills icon",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.kills.paste"),
      type: "url",
      collection: true,
      set: function (p18136) {
        p18136 = UTILS.isURL(p18136) && !/\.svg/.test(p18136) ? p18136 : "";
        killsIcon.src = p18136.length > 1 ? p18136 : "./img/skull_0.png";
      }
    },
    customDeaths: {
      name: "settings.mods.deaths",
      info: "Replace default deaths icon",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.deaths.paste"),
      type: "url",
      collection: true,
      set: function (p18137) {
        p18137 = UTILS.isURL(p18137) && !/\.svg/.test(p18137) ? p18137 : "";
        deathsIcon.src = p18137.length > 1 ? p18137 : "./img/skull_1.png";
      }
    },
    customStreak: {
      name: "settings.mods.streak",
      info: "Replace default killstreak icon",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.streak.paste"),
      type: "url",
      collection: true,
      set: function (p18138) {
        p18138 = UTILS.isURL(p18138) && !/\.svg/.test(p18138) ? p18138 : "";
        streakIcon.src = p18138.length > 1 ? p18138 : "./img/skull_2.png";
      }
    },
    useDamageOverlay: {
      name: "settings.mods.usedamage",
      info: "Display damage overlay. Appears when taking damage in-game",
      cat: "mods",
      pro: false,
      perf: false,
      val: true,
      toggle: true,
      type: "switch",
      set: function (p18139) {
        vThis142.tmp[this.key] = p18139;
        if (!p18139) {
          p17845.bloodOpacity = 0;
          bloodDisplay.style.display = "none";
          bloodDisplay.style.opacity = 0;
        }
      }
    },
    customDamage: {
      name: "settings.mods.damage",
      info: "Replace default damage image",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.damage.paste"),
      type: "url",
      collection: true,
      set: function (p18140) {
        p18140 = UTILS.isURL(p18140) && !/\.svg/.test(p18140) ? p18140 : "";
        if (/\.(jpg|jpeg|png)/.test(p18140)) {
          p17845.bloodLoaded = false;
          p17845.bloodImage.src = p18140;
          p17845.bloodCustom = false;
        } else {
          bloodDisplay.src = p18140.length > 1 ? p18140 : "./img/blood.png";
          if (p17845.bloodImage.src != "./img/blood.png") {
            p17845.bloodLoaded = false;
            p17845.bloodImage.src = "./img/blood.png";
          }
          p17845.bloodCustom = p18140.length > 1;
        }
      }
    },
    customGameOverlay: {
      name: "settings.mods.overlay",
      info: "Replace default overlay image",
      cat: "mods",
      val: "",
      img: true,
      placeholder: p17847.t("settings.mods.overlay.paste"),
      type: "url",
      collection: true,
      set: function (p18141) {
        p18141 = UTILS.isURL(p18141) && !/\.svg/.test(p18141) ? p18141 : "";
        overlay.style.backgroundImage = p18141.length > 1 ? "url('" + p18141 + "')" : "";
      }
    },
    scoreBoardTrigger: {
      name: "settings.controls.leaderboard",
      cat: "controls",
      hide: true,
      noShow: true,
      val: 1,
      options: {
        0: "Press (Toggle)",
        1: "Continuous (Hold)"
      },
      type: "select",
      set: function (p18142) {
        vThis142.tmp[this.key] = p18142;
      }
    },
    voiceChatTrigger: {
      name: "settings.controls.voicechat",
      cat: "controls",
      hide: true,
      noShow: true,
      val: 1,
      options: {
        0: "Press (Toggle)",
        1: "Continuous (Hold)"
      },
      type: "select",
      set: function (p18143) {
        vThis142.tmp[this.key] = p18143;
      }
    }
  };
  this.init = function () {
    var v13943 = Object.keys(this.list).filter(p18144 => this.list[p18144].perWep || this.list[p18144].perWepG);
    for (var vLN02548 = 0; vLN02548 < p17841.weapons.length; vLN02548++) {
      var v13944;
      for (var vLN02549 = 0; vLN02549 < v13943.length; vLN02549++) {
        v13944 = this.list[v13943[vLN02549]];
        v13944.weapon = -1;
        this.list[v13943[vLN02549] + "_" + vLN02548] = {
          ...v13944
        };
        this.list[v13943[vLN02549] + "_" + vLN02548].hide = true;
        this.list[v13943[vLN02549] + "_" + vLN02548].perWep = false;
        this.list[v13943[vLN02549] + "_" + vLN02548].perWepG = false;
        this.list[v13943[vLN02549] + "_" + vLN02548].weapon = vLN02548;
      }
    }
    for (var v13945 in this.list) {
      this.tmp[v13945] = this.list[v13945].val;
      this.list[v13945].key = v13945;
      this.list[v13945].def = this.list[v13945].val;
      if (this.list[v13945].set && !this.list[v13945].dontInit) {
        var kro_setngss_ = getSavedVal("kro_setngss_" + v13945);
        this.list[v13945].val = kro_setngss_ === null ? this.list[v13945].val : kro_setngss_;
        if (this.list[v13945].val == "false") {
          this.list[v13945].val = false;
        }
        if (this.list[v13945].val == "true") {
          this.list[v13945].val = true;
        }
        if (this.list[v13945].val == "undefined") {
          this.list[v13945].val = this.list[v13945].def;
        }
        this.list[v13945].val = this.list[v13945].val && this.list[v13945].val.replace ? this.list[v13945].val.replace(/[><]/g, "") : this.list[v13945].val;
        if (this.list[v13945].testfor && !this.list[v13945].testfor.test(this.list[v13945].val)) {
          this.list[v13945].val = this.list[v13945].def;
        }
        if (this.list[v13945].img && !/\.(jpg|jpeg|png|gif|webp|ico)/.test(this.list[v13945].val)) {
          this.list[v13945].val = this.list[v13945].def;
        }
        if (this.list[v13945].type && this.list[v13945].color && !UTILS.isHexColor(this.list[v13945].val)) {
          this.list[v13945].val = this.list[v13945].def;
        }
        if ((this.list[v13945].str || this.list[v13945].img) && this.list[v13945].val && this.list[v13945].val.replace) {
          this.list[v13945].val = this.list[v13945].val.replace(/\u0027/g, "").replace(/\u0022/g, "");
        }
        if (this.list[v13945].min || this.list[v13945].max) {
          this.list[v13945].val = Math.min(this.list[v13945].max, Math.max(this.list[v13945].min, +this.list[v13945].val));
        }
        if (this.list[v13945].type == "switch") {
          this.list[v13945].val = !!this.list[v13945].val;
        }
        this.list[v13945].set(this.list[v13945].val, true);
      }
    }
  };
  this.set = function (p18145, p18146, p18147, p18148, p18149) {
    if (vThis142.list[p18145]) {
      p18146 = p18146 === null ? vThis142.list[p18145].val : p18146;
      p18146 = p18146 && p18146.replace ? p18146.replace(/[><]/g, "") : p18146;
      if (p18146 == "false") {
        p18146 = false;
      }
      if (p18146 == "true") {
        p18146 = true;
      }
      if (p18146 == "undefined") {
        p18146 = vThis142.list[p18145].def;
      }
      if (p18148 && vThis142.list[p18145].testfor && !vThis142.list[p18145].testfor.test(p18146)) {
        p18146 = vThis142.list[p18145].def;
      }
      if (vThis142.list[p18145].img && !/\.(jpg|jpeg|png|gif|webp|ico)/.test(p18146)) {
        p18146 = vThis142.list[p18145].def;
      }
      if (vThis142.list[p18145].type && vThis142.list[p18145].color && !UTILS.isHexColor(p18146)) {
        p18146 = vThis142.list[p18145].def;
      }
      if ((vThis142.list[p18145].str || vThis142.list[p18145].img) && p18146 && p18146.replace) {
        p18146 = p18146.replace(/\u0027/g, "").replace(/\u0022/g, "");
      }
      if (vThis142.list[p18145].min || vThis142.list[p18145].max) {
        p18146 = Math.min(vThis142.list[p18145].max, Math.max(vThis142.list[p18145].min, +p18146));
      }
      if (this.list[p18145].type == "switch") {
        p18146 = !!p18146;
      }
      if (document.getElementById("slid_" + p18145)) {
        document.getElementById("slid_" + p18145).value = p18146;
      }
      if (document.getElementById("slid_input_" + p18145)) {
        document.getElementById("slid_input_" + p18145).value = p18146;
      }
      if (!p18149) {
        vThis142.list[p18145].val = p18146;
      }
      vThis142.list[p18145].set(p18146);
      if (!p18149) {
        saveVal("kro_setngss_" + p18145, p18146);
      }
      if (!p18147) {
        selectSettingPre(2, true);
      }
    }
  };
  this.export = function (p18150) {
    var vO471 = {};
    var v13946 = p17840.export();
    for (var v13947 in vThis142.list) {
      if (vThis142.list[v13947].val != vThis142.list[v13947].def) {
        vO471[v13947] = vThis142.list[v13947].val;
      }
    }
    if (Object.keys(v13946).length) {
      vO471.controls = v13946;
    }
    var v13948 = window.customizeExport();
    if (Object.keys(v13948).length) {
      vO471.customize = v13948;
    }
    if (p18150) {
      return JSON.stringify(vO471);
    } else {
      downloadFile("settings.txt", vO471);
      return;
    }
  };
  this.import = function (p18151) {
    var v13949 = p18151 || prompt("Copy Paste Settings Text Here");
    if (v13949 && v13949 != "") {
      try {
        let v13950 = JSON.parse(v13949);
        for (var v13951 in vThis142.list) {
          var v13952 = v13950[v13951] == null ? vThis142.list[v13951].def : v13950[v13951];
          setSetting(v13951, v13952, null, true);
        }
        if (v13950.controls) {
          for (var v13953 in v13950.controls) {
            var v13954 = v13953.includes("_alt");
            if (v13953.startsWith("moveKeys") || v13953.startsWith("streakKeys") || v13953.startsWith("tauntKeys") || v13953.startsWith("toggleKeys") || v13953.startsWith("premiumKeys") || v13953.startsWith("messageKeys")) {
              var v13955;
              for (var vLN02552 = 0; vLN02552 < v13950.controls[v13953].length; vLN02552++) {
                v13955 = v13953.replace("Keys", "").replace("_alt", "");
                if (p17840.binds[v13955] && p17840.binds[v13955][vLN02552]) {
                  if (v13950.controls[v13953][vLN02552] == null) {
                    v13950.controls[v13953][vLN02552] = p17840.binds[v13955][vLN02552][v13954 ? "altVal" : "val"];
                  }
                  p17840.updateBind(v13955, v13954, vLN02552, v13950.controls[v13953][vLN02552], true);
                }
              }
            } else if (v13953 == "toggleSets") {
              if (!Array.isArray(v13950.controls[v13953])) {
                continue;
              }
              for (var vLN02552 = 0; vLN02552 < p17840[v13953].length; vLN02552++) {
                p17840[v13953][vLN02552] = vThis142.list[v13950.controls[v13953][vLN02552]] ? v13950.controls[v13953][vLN02552] : "";
              }
            } else if (v13953 == "chatMessages") {
              if (!Array.isArray(v13950.controls[v13953])) {
                continue;
              }
              for (var vLN02552 = 0; vLN02552 < p17840[v13953].length; vLN02552++) {
                p17840[v13953][vLN02552] = window.filterCM(v13950.controls[v13953][vLN02552] || "") || "";
              }
            } else {
              var bind = p17840.getBindByName(v13953);
              if (bind) {
                bind.update(v13950.controls[v13953], v13954);
              }
            }
          }
        }
        if (v13950.customize) {
          var v13957 = v13950.customize;
          if (v13957.loadouts) {
            window.windows[2].import(v13957.loadouts);
          }
          if (v13957.reticles) {
            window.setCustomRets(v13957.reticles, true);
          }
          if (v13957.scopes) {
            window.setCustomScopes(v13957.scopes, true);
          }
          if (v13957.images) {
            window.setCustomImages(v13957.images, true);
          }
          if (v13957.favorites) {
            window.updateFavList(v13957.favorites, true);
          }
        }
        p17840.checkScroll();
        if (!p18151) {
          showWindow(1);
        }
      } catch (e176) {
        alert("Failed to import settings with error:\n" + e176.toString());
      }
    }
  };
};